;
export const localeMessage = {
  en: {
    noData: `no data`,
    allPermissions: `No sub permissions`,
    1: `Ginee Package`,
    101: `Account & Current Package`,
    102: `Package Price`,
    2: `Store Sync`,
    3: `Dashboard`,
    4: `Orders`,
    401: `Nearly 90 days order`,
    40101: `Export Order`,
    40103: `SyncOrders`,
    40104: `Receive Order`,
    40105: `Cancel Order`,
    40106: `Accept Cencelation`,
    40107: `Pack Order`,
    40108: `Arrange Shipment`,
    40109: `Mass Update To Waiting Shipment`,
    40110: `Print Shipping Label`,
    40111: `Mass Print Label`,
    40112: `Print Picking List`,
    40113: `Print Packing List`,
    40114: `Print Invoice`,
    40115: `See the details`,
    40116: `Set as completed`,
    40117: `Set picking status`,
    40118: `Set packaging status`,
    40119: `Setprinting status`,
    40120: `Set picking notes`,
    40121: `Set seller notes`,
    40122: `Operation Record`,
    40123: `Move to Shipped`,
    40124: `Add Order`,
    4012401: `Reference Order`,
    4012402: `Select customer`,
    4012403: `Add Product`,
    40125: `Import Order`,
    40126: `Move To Returned`,
    40127: `Edit order`,
    40128: `Inbound Return Product`,
    40129: `Set Ready To Ship`,
    40130: `Change Warehouse`,
    40131: `Replace Product`,
    40132: `Add Gift`,
    40133: `Mark as fake order`,
    402: `Order Process`,
    40201: `Pending`,
    4020101: `Processing Order`,
    4020102: `Cancel Order`,
    4020103: `Push Warehouse to  Shipment`,
    4020104: `Put On Hold`,
    4020105: `Check stock`,
    4020106: `Replacing Master SKU`,
    4020107: `Export Order`,
    4020108: `Sync Orders`,
    4020109: `Arrange Shipment`,
    4020110: `Receive Order`,
    4020111: `Pack Order`,
    4020112: `Print Shipping Label`,
    4020113: `Mass Print Label`,
    4020114: `Print Picking List`,
    4020115: `Print Packing List`,
    4020116: `Print Invoice`,
    4020117: `Set picking status`,
    4020118: `Set packaging status`,
    4020119: `Set printing status`,
    4020120: `Operation Record`,
    4020121: `Re-distribute`,
    4020122: `Delivery Warehouse`,
    4020123: `Change Warehouse`,
    4020124: `Replace Product`,
    4020125: `Add Gift`,
    4020126: `Mark as fake order`,
    40202: `Pending print order`,
    4020201: `Print Shipping Label`,
    4020202: `Mass Print Label`,
    4020203: `Print Packing List`,
    4020204: `Print Picking List`,
    4020205: `Sync Orders`,
    4020206: `Move to Pending Collection`,
    4020207: `Move to Shipped`,
    4020208: `Export Order`,
    4020209: `Set picking status`,
    4020210: `Set packaging status`,
    4020211: `Set printing status`,
    4020212: `Operation Record`,
    4020213: `Put On Hold`,
    4020214: `Cancel Order`,
    4020215: `Change Warehouse`,
    4020216: `Replace Product`,
    4020217: `Add Gift`,
    4020218: `Mark as fake order`,
    4020219: `Arrange Shipment`,
    40203: `To be collected`,
    4020301: `Print Shipping Label`,
    4020302: `Mass Print Label`,
    4020303: `Print Packing List`,
    4020304: `Print Picking List`,
    4020305: `Sync Orders`,
    4020306: `Move to Shipped`,
    4020307: `Export Order`,
    4020308: `Set picking status`,
    4020309: `Set packaging status`,
    4020310: `Set printing status`,
    4020311: `Operation Record`,
    4020312: `Print Invoice`,
    4020313: `Mark as fake order`,
    40204: `Shipped`,
    4020401: `Print Shipping Label`,
    4020402: `Mass Print Label`,
    4020403: `Print Packing List`,
    4020404: `Print Picking List`,
    4020405: `Sync Orders`,
    4020406: `Move to Shipped`,
    4020407: `Export Order`,
    4020408: `Set picking status`,
    4020409: `Set packaging status`,
    4020410: `Set printing status`,
    4020411: `Operation Record`,
    4020412: `Mark as fake order`,
    40206: `Stored`,
    4020601: `Sync Orders`,
    4020602: `Export Order`,
    4020603: `Set picking status`,
    4020604: `Set packaging status`,
    4020605: `Set printing status`,
    4020606: `Operation Record`,
    4020607: `Mark as fake order`,
    403: `Abnormal Order`,
    40301: `Sync Orders`,
    40302: `Operation Record`,
    404: `Order Log`,
    405: `Order Settings`,
    40501: `Shipping Rule Settings`,
    4050101: `Add New Rule`,
    4050102: `Edit Rule`,
    4050103: `Delete Rule`,
    40502: `Shipping Warehouse Setting`,
    4050201: `Add New Rule`,
    4050202: `Edit Rule`,
    4050203: `Activate Rule`,
    4050204: `Deactivation Rule`,
    4050205: `View Operation Log`,
    40503: `Shipping Label Information Settings`,
    40504: `Template Settings`,
    4050401: `Shipping Label Template Settings`,
    4050402: `Pick List Template Settings`,
    4050403: `Invoice Template Settings`,
    4050404: `Packing List Template Settings`,
    40505: `Export Settings`,
    4050501: `New Template`,
    4050502: `Edit Template`,
    4050503: `Delete Template`,
    40506: `LA Invoice Rule Setting`,
    4050601: `Add New Rule`,
    4050602: `Edit Rule`,
    4050603: `Delete Rule`,
    40507: `Commission Setting`,
    4050701: `Edit Commission`,
    40508: `Distribution Settings`,
    4050801: `Operation Log`,
    406: `Return Management`,
    40601: `Refund List`,
    4060101: `Accept`,
    4060102: `Reject`,
    4060103: `Sync`,
    4060104: `View Return Records`,
    4060105: `Accept Refund`,
    4060106: `Reject Refund`,
    4060107: `Inbound Return Product`,
    40602: `Return & Refund`,
    4060201: `Accept`,
    4060202: `Reject`,
    4060203: `Sync`,
    4060204: `View Return Records`,
    4060205: `Accept Refund`,
    4060206: `Reject Refund`,
    4060207: `Inbound Return Product`,
    407: `Historical Orders`,
    40701: `Operation Log`,
    40702: `SyncOrders`,
    40703: `Export Order`,
    408: `Utility tool`,
    40801: `Scan shipment`,
    40802: `Print Hot Item Label`,
    40207: `Print Hot Item Label`,
    4020701: `Additional print label`,
    409: `Pending`,
    40901: `Arrange Shipment`,
    4090101: `Add Gift`,
    4090102: `Operation Record`,
    4090103: `Change Warehouse`,
    4090104: `Replace Product`,
    4090105: `Mark as fake order`,
    4090106: `Put On Hold`,
    4090107: `SyncOrders`,
    4090108: `Receive Order`,
    4090109: `Cancel Order`,
    4090110: `Print Shipping Label`,
    4090111: `Mass Print Label`,
    4090112: `Print Picking List`,
    4090113: `Print Packing List`,
    4090114: `Print Invoice`,
    4090115: `Set picking status`,
    4090116: `Set packaging status`,
    4090117: `Setprinting status`,
    4090118: `Arrange Shipment`,
    4090119: `Pack Order`,
    40902: `Push Warehouse`,
    4090201: `Add Gift`,
    4090202: `Operation Record`,
    4090203: `Change Warehouse`,
    4090204: `Replace Product`,
    4090205: `Mark as fake order`,
    4090206: `Put On Hold`,
    4090207: `Delivery Warehouse`,
    4090208: `Print Shipping Label`,
    4090209: `Mass Print Label`,
    4090210: `Print Picking List`,
    4090211: `Print Packing List`,
    4090212: `Print Invoice`,
    4090213: `Set picking status`,
    4090214: `Set packaging status`,
    4090215: `Setprinting status`,
    40903: `Problem Order`,
    4090301: `Add Gift`,
    4090302: `Operation Record`,
    4090303: `Change Warehouse`,
    4090304: `Replace Product`,
    4090305: `Mark as fake order`,
    4090306: `Put On Hold`,
    4090307: `Print Shipping Label`,
    4090308: `Mass Print Label`,
    4090309: `Print Picking List`,
    4090310: `Print Packing List`,
    4090311: `Print Invoice`,
    4090312: `Set picking status`,
    4090313: `Set packaging status`,
    4090314: `Setprinting status`,
    4090315: `Re-distribute`,
    4090316: `SyncOrders`,
    4090317: `Arrange Shipment`,
    5: `Master Product`,
    501: `Master Product List`,
    50101: `Add Product`,
    50102: `Import/Export`,
    50103: `Edit Products (including batches)`,
    50104: `Copy Master Product (including batches)`,
    50105: `Publish to store`,
    50106: `Delete Master Product`,
    50107: `Mass unbind`,
    50108: `Temporary Untracked`,
    50109: `Copy Master Product`,
    50201: `Import/Export`,
    502: `Price management`,
    50202: `Sync Promotion`,
    503: `Product Settings`,
    50301: `Master Product Setting`,
    5030101: `Auto Bind MSKU`,
    5030102: `Auto Create MSKU`,
    50302: `Add Product Settings`,
    50303: `Copy Settings`,
    50304: `Product Activity Settings`,
    50305: `Barcode Printing Template Settings`,
    6: `Channel Product`,
    601: `Product List`,
    60101: `Add Product`,
    60102: `Edit Stock`,
    60103: `Edit Product`,
    60104: `Copy Product`,
    60105: `Synchronize Poducts`,
    60106: `Delete Product`,
    60107: `Active Product`,
    60108: `Deactive Product`,
    60109: `Mass Publish`,
    60110: `MassEditing`,
    60111: `Mass Delete`,
    60112: `Mass Copy`,
    60113: `Mass Activate`,
    60114: `Mass Deactive`,
    60115: `Product Import/Export`,
    60116: `Create a Product Master`,
    602: `Product Tools`,
    60201: `Product Scrape`,
    6020101: `Scrape List`,
    6020102: `One-click Scraping`,
    60202: `Clone Store`,
    7: `Stock`,
    701: `Stock Management`,
    70101: `ISKU list`,
    70102: `Export/Import ISKU Data`,
    70103: `Add ISKU`,
    70104: `Edit ISKU`,
    70105: `Delete ISKU`,
    70106: `Change ISKU Stock`,
    70107: `Stock Change Record`,
    710: `Reserved Stock`,
    702: `Stock List`,
    70213: `Export`,
    70214: `Import`,
    70202: `Edit Warehouse Stock`,
    70204: `Push Stock`,
    70206: `Modify the average purchase unit price`,
    70207: `Set Spare Stock`,
    70208: `Edit`,
    70209: `Add Product to Warehouse`,
    70210: `Safety Stock Settings`,
    70211: `Email Notification Setting`,
    70212: `Stock Warning`,
    70215: `Delete`,
    70216: `Hide Average Purchase Price`,
    703: `Stock Change Record`,
    704: `Stock Push Record`,
    705: `Stock Pull Record`,
    707: `Stock Push Rule`,
    708: `Stock Push Rule`,
    70801: `Add Rule`,
    70802: `Main Store Stock Locked`,
    70803: `Execute Rules`,
    70804: `Edit`,
    70805: `Delete`,
    70806: `Enable/Close`,
    709: `Store Push Record`,
    706: `Stock Settings`,
    70601: `Stock Monitor and Sync`,
    70602: `Main Store Stock Lock`,
    8: `Warehouse`,
    801: `Warehouse list`,
    802: `Shelf Management`,
    804: `Outbound Management`,
    80401: `View`,
    80402: `Operate`,
    805: `Inbound Management`,
    80501: `View`,
    80502: `Operate`,
    806: `Stock In/Out Record`,
    807: `3rd Party Warehouse Pull Stock`,
    809: `WMS warehouse`,
    80901: `Product Information`,
    810: `Accurate Warehouse`,
    81001: `Product Push Record`,
    81002: `Order Push Record`,
    811: `Stocktaking`,
    81101: `Add`,
    81102: `Export/Import`,
    81103: `Start counting`,
    81104: `Edit`,
    81105: `Delete`,
    81106: `Continue counting`,
    81107: `Finish Stoktaking`,
    81108: `Set as invalid`,
    81109: `Print Stock Opname List`,
    81110: `Generate Stock Adjustment List`,
    81111: `Create Stock Opname List`,
    812: `Stock adjustment`,
    81201: `Start adjusting`,
    81202: `Set as invalid`,
    81203: `Continue to adjust`,
    81204: `Confirm adjustment`,
    81205: `Single adjustment`,
    81206: `Without adjustment`,
    813: `Keeppack warehouse`,
    81301: `Product Info`,
    8130101: `Binding MSKU`,
    8130102: `Pull product`,
    8130103: `Create Master Product`,
    8130104: `Config Management`,
    8130105: `Unbind MSKU`,
    81302: `Inbound Management`,
    8130201: `Push`,
    8130202: `Set as invalid`,
    8130203: `Create Inbound List`,
    81303: `Outbound Management`,
    8130301: `Push`,
    8130302: `Set as invalid`,
    81304: `Stock pull record`,
    814: `KONGFU warehouse`,
    81401: `Product Info`,
    8140101: `Binding MSKU`,
    8140102: `Pull product`,
    8140103: `Create Master Product`,
    8140104: `Config Management`,
    8140105: `Unbind MSKU`,
    81402: `Inbound Management`,
    8140201: `Push`,
    8140202: `Set as invalid`,
    8140203: `Create Inbound List`,
    81403: `Outbound Management`,
    8140301: `Push`,
    8140302: `Set as invalid`,
    81404: `Stock pull record`,
    9: `Promotion`,
    901: `Discount Management`,
    90101: `Discount List`,
    9010101: `Sync Promotion`,
    9010102: `Add Promotion`,
    9010103: `Mass Add Promotion`,
    9010104: `Promotion Details`,
    9010105: `Edit Promotion`,
    9010106: `Delete Promotion`,
    9010107: `Delete Promotion Massal`,
    9010108: `Pause Promotion`,
    9010109: `Import Promotion`,
    9010110: `Create in batches using templates`,
    9010111: `View Mass Add History`,
    90102: `Promotion template`,
    9010201: `New Template`,
    9010202: `Edit Template`,
    9010203: `Delete Template`,
    902: `Auto Bump`,
    90201: `Edit Boost Information`,
    90202: `Edit Store Status`,
    90203: `Add New Boost Products`,
    90204: `Remove Boost Products`,
    90205: `Set-up Boost Rules`,
    10: `Customer`,
    1001: `Customer List`,
    100101: `Export Selected Customers`,
    100102: `Export All Customers`,
    100103: `View Export History`,
    100104: `Add Customer`,
    100105: `Import Customer`,
    100106: `Edit Customer`,
    100107: `Delete Customer`,
    100108: `View Customers`,
    100109: `Set-up Customer Groups`,
    100110: `Set as blacklisted`,
    1002: `Customer Group`,
    100201: `New Group`,
    100202: `Edit Group`,
    100203: `Delete Group`,
    11: `Reports`,
    1101: `Sales Report`,
    110101: `Order Report`,
    11010101: `Export Report`,
    11010102: `View Export History`,
    110102: `Product Sales Report`,
    110107: `Master product sales`,
    110108: `Master Product Activity`,
    11010201: `Export Report`,
    11010202: `View Export History`,
    110103: `Product Variation Sales Report`,
    11010301: `Export Report`,
    11010302: `View Export History`,
    110104: `Channel Sales Report`,
    11010401: `Export Report`,
    11010402: `View Export History`,
    110105: `Store Sale Report`,
    11010501: `Export Report`,
    11010502: `View Export History`,
    110106: `Income Statement (Available with "stock List" permission)`,
    11010601: `Export to Excel`,
    11010602: `Export to PDF`,
    11010603: `View Export History`,
    1102: `Inventory Report`,
    110203: `Stock Value`,
    110201: `Out of Stock Estimation`,
    11020101: `Restock`,
    11020102: `Export Report`,
    11020103: `Export Report`,
    110202: `Slow Sales Statistics Table`,
    11020201: `Export Report`,
    11020202: `View Export History`,
    11020203: `Customized`,
    12: `Integration`,
    1201: `StoreList`,
    120101: `Edit Store Info`,
    120102: `Unbind`,
    120103: `Add Store`,
    120104: `Warehouse Management`,
    120105: `Confirm Integrations`,
    120106: `Pull Warehouse`,
    120107: `Bind`,
    120108: `Update`,
    120109: `Operation Log`,
    1202: `Add Integration`,
    14: `Chat`,
    1405: `Download Windows Chat`,
    1406: `Download MacOS Chat`,
    1401: `Manage Chat`,
    1402: `Enable Chat`,
    1403: `Disable Chat`,
    1404: `Auto Login Settings`,
    15: `Settings`,
    1501: `Basic Settings`,
    1502: `Product Settings`,
    1503: `Order Settings`,
    1504: `Stock Settings`,
    1505: `Shipping Settings`,
    150501: `Shipping Settings List`,
    150502: `Shipping On/Off Setting`,
    1506: `Staff Management`,
    150601: `Staff List`,
    150602: `Add Staff`,
    150603: `Edit Staff`,
    150604: `Delete Staff`,
    1507: `Role Management`,
    150701: `Role List`,
    150702: `Add New Role`,
    150703: `View Role`,
    150704: `Edit Role`,
    150705: `Delete Role`,
    1508: `Fulfillment Settings`,
    150801: `JD Fulfillment Service`,
    15080101: `Add Department`,
    150802: `Fastock Fulfillment Service`,
    15080201: `Add Warehouse`,
    150803: `Ginee Fulfillment Service`,
    15080301: `Add Warehouse`,
    1509: `Reset Password`,
    16: `logistics`,
    1601: `Check shipping fee`,
    808: `Third Party Warehouse Product List`,
    80801: `Synchronize`,
    80802: `Create Master Product`,
    80803: `Binding Record`,
    80804: `Sync Warehouse Product`,
    80805: `Bind MSKU`,
    80806: `Unbind MSKU`,
    18: `Purchase`,
    1801: `Supplier Management`,
    180101: `View`,
    180102: `Operate`,
    1802: `Purchase Order`,
    180201: `View`,
    180202: `Operate`,
    180203: `Export`
  },
  zh: {
    noData: `\u65E0\u6570\u636E`,
    allPermissions: `\u65E0\u5B50\u6743\u9650`,
    1: `Ginee\u5957\u9910`,
    101: `\u8D26\u6237&\u5F53\u524D\u5957\u9910`,
    102: `\u5957\u9910&\u4EF7\u683C`,
    2: `\u5E97\u94FA\u540C\u6B65`,
    3: `\u6570\u636E\u7EDF\u8BA1`,
    4: `\u8BA2\u5355`,
    401: `\u8FD190\u5929\u8BA2\u5355`,
    40101: `\u5BFC\u51FA\u8BA2\u5355`,
    40103: `\u540C\u6B65\u8BA2\u5355`,
    40104: `\u63A5\u53D7\u8BA2\u5355`,
    40105: `\u53D6\u6D88\u8BA2\u5355`,
    40106: `\u5904\u7406\u53D6\u6D88\u5355`,
    40107: `\u6253\u5305`,
    40108: `\u5B89\u6392\u53D1\u8D27`,
    40109: `\u6279\u91CF\u66F4\u65B0\u81F3\u5F85\u53D1\u8D27`,
    40110: `\u6253\u5370\u5FEB\u9012\u5355`,
    40111: `\u6279\u91CF\u6253\u5370\u5FEB\u9012\u5355`,
    40112: `\u6253\u5370\u62E3\u8D27\u5355`,
    40113: `\u6253\u5370\u88C5\u7BB1\u5355`,
    40114: `\u6253\u5370\u53D1\u7968`,
    40115: `\u67E5\u770B\u8BE6\u60C5`,
    40116: `\u8BBE\u7F6E\u4E3A\u5DF2\u5B8C\u6210`,
    40117: `\u8BBE\u7F6E\u62E3\u8D27\u72B6\u6001`,
    40118: `\u8BBE\u7F6E\u6253\u5305\u72B6\u6001`,
    40119: `\u8BBE\u7F6E\u6253\u5370\u72B6\u6001`,
    40120: `\u8BBE\u7F6E\u62E3\u8D27\u5907\u6CE8`,
    40121: `\u8BBE\u7F6E\u5356\u5BB6\u5907\u6CE8`,
    40122: `\u64CD\u4F5C\u65E5\u5FD7`,
    40123: `\u79FB\u81F3\u5DF2\u53D1\u8D27`,
    40124: `\u65B0\u589E\u8BA2\u5355`,
    4012401: `\u5F15\u7528\u8BA2\u5355`,
    4012402: `\u9009\u62E9\u5BA2\u6237`,
    4012403: `\u6DFB\u52A0\u5546\u54C1`,
    40125: `\u5BFC\u5165\u8BA2\u5355`,
    40126: `\u79FB\u5165\u5DF2\u9000\u8D27`,
    40127: `\u4FEE\u6539\u8BA2\u5355`,
    40128: `\u9000\u8D27\u5165\u5E93`,
    40129: `\u79FB\u5165\u5F85\u53D1\u8D27`,
    40130: `\u66F4\u6362\u4ED3\u5E93`,
    40131: `\u66F4\u6362\u5546\u54C1`,
    40132: `\u6DFB\u52A0\u8D60\u54C1`,
    40133: `\u5237\u5355\u6807\u8BB0`,
    402: `\u8BA2\u5355\u5904\u7406`,
    40201: `\u5F85\u5904\u7406`,
    4020101: `\u5904\u7406\u8BA2\u5355`,
    4020102: `\u53D6\u6D88\u8BA2\u5355`,
    4020103: `\u63A8\u9001\u4ED3\u5E93\u53D1\u8D27`,
    4020104: `\u6401\u7F6E`,
    4020105: `\u68C0\u67E5\u5E93\u5B58`,
    4020106: `\u66F4\u6362\u4E3BSKU`,
    4020107: `\u5BFC\u51FA\u8BA2\u5355`,
    4020108: `\u540C\u6B65\u8BA2\u5355`,
    4020109: `\u5B89\u6392\u53D1\u8D27`,
    4020110: `\u63A5\u53D7\u8BA2\u5355`,
    4020111: `\u6253\u5305`,
    4020112: `\u6253\u5370\u5FEB\u9012\u5355`,
    4020113: `\u6279\u91CF\u6253\u5370\u5FEB\u9012\u5355`,
    4020114: `\u6253\u5370\u62E3\u8D27\u5355`,
    4020115: `\u6253\u5370\u88C5\u7BB1\u5355`,
    4020116: `\u6253\u5370\u53D1\u7968`,
    4020117: `\u8BBE\u7F6E\u62E3\u8D27\u72B6\u6001`,
    4020118: `\u8BBE\u7F6E\u6253\u5305\u72B6\u6001`,
    4020119: `\u8BBE\u7F6E\u6253\u5370\u72B6\u6001`,
    4020120: `\u64CD\u4F5C\u65E5\u5FD7`,
    4020121: `\u91CD\u65B0\u914D\u8D27`,
    4020122: `\u4E0B\u53D1\u4ED3\u5E93`,
    4020123: `\u66F4\u6362\u4ED3\u5E93`,
    4020124: `\u66F4\u6362\u5546\u54C1`,
    4020125: `\u6DFB\u52A0\u8D60\u54C1`,
    4020126: `\u5237\u5355\u6807\u8BB0`,
    40202: `\u5F85\u6253\u5355`,
    4020201: `\u6253\u5370\u5FEB\u9012\u5355`,
    4020202: `\u6279\u91CF\u6253\u5370\u5FEB\u9012\u5355`,
    4020203: `\u6253\u5370\u88C5\u7BB1\u5355`,
    4020204: `\u6253\u5370\u62E3\u8D27\u5355`,
    4020205: `\u540C\u6B65\u8BA2\u5355`,
    4020206: `\u79FB\u81F3\u5F85\u63FD\u6536`,
    4020207: `\u79FB\u81F3\u5DF2\u53D1\u8D27`,
    4020208: `\u5BFC\u51FA\u8BA2\u5355`,
    4020209: `\u8BBE\u7F6E\u62E3\u8D27\u72B6\u6001`,
    4020210: `\u8BBE\u7F6E\u6253\u5305\u72B6\u6001`,
    4020211: `\u8BBE\u7F6E\u6253\u5370\u72B6\u6001`,
    4020212: `\u64CD\u4F5C\u65E5\u5FD7`,
    4020213: `\u6401\u7F6E`,
    4020214: `\u53D6\u6D88\u8BA2\u5355`,
    4020215: `\u66F4\u6362\u4ED3\u5E93`,
    4020216: `\u66F4\u6362\u5546\u54C1`,
    4020217: `\u6DFB\u52A0\u8D60\u54C1`,
    4020218: `\u5237\u5355\u6807\u8BB0`,
    4020219: `\u5B89\u6392\u53D1\u8D27`,
    40203: `\u5F85\u63FD\u6536`,
    4020301: `\u6253\u5370\u5FEB\u9012\u5355`,
    4020302: `\u6279\u91CF\u6253\u5370\u5FEB\u9012\u5355`,
    4020303: `\u6253\u5370\u88C5\u7BB1\u5355`,
    4020304: `\u6253\u5370\u62E3\u8D27\u5355`,
    4020305: `\u540C\u6B65\u8BA2\u5355`,
    4020306: `\u79FB\u81F3\u5DF2\u53D1\u8D27`,
    4020307: `\u5BFC\u51FA\u8BA2\u5355`,
    4020308: `\u8BBE\u7F6E\u62E3\u8D27\u72B6\u6001`,
    4020309: `\u8BBE\u7F6E\u6253\u5305\u72B6\u6001`,
    4020310: `\u8BBE\u7F6E\u6253\u5370\u72B6\u6001`,
    4020311: `\u64CD\u4F5C\u65E5\u5FD7`,
    4020312: `\u6253\u5370\u53D1\u7968`,
    4020313: `\u5237\u5355\u6807\u8BB0`,
    40204: `\u5DF2\u53D1\u8D27`,
    4020401: `\u6253\u5370\u5FEB\u9012\u5355`,
    4020402: `\u6279\u91CF\u6253\u5370\u5FEB\u9012\u5355`,
    4020403: `\u6253\u5370\u88C5\u7BB1\u5355`,
    4020404: `\u6253\u5370\u62E3\u8D27\u5355`,
    4020405: `\u540C\u6B65\u8BA2\u5355`,
    4020406: `\u79FB\u81F3\u5DF2\u53D1\u8D27`,
    4020407: `\u5BFC\u51FA\u8BA2\u5355`,
    4020408: `\u8BBE\u7F6E\u62E3\u8D27\u72B6\u6001`,
    4020409: `\u8BBE\u7F6E\u6253\u5305\u72B6\u6001`,
    4020410: `\u8BBE\u7F6E\u6253\u5370\u72B6\u6001`,
    4020411: `\u64CD\u4F5C\u65E5\u5FD7`,
    4020412: `\u5237\u5355\u6807\u8BB0`,
    40206: `\u5DF2\u6401\u7F6E`,
    4020601: `\u540C\u6B65\u8BA2\u5355`,
    4020602: `\u5BFC\u51FA\u8BA2\u5355`,
    4020603: `\u8BBE\u7F6E\u62E3\u8D27\u72B6\u6001`,
    4020604: `\u8BBE\u7F6E\u6253\u5305\u72B6\u6001`,
    4020605: `\u8BBE\u7F6E\u6253\u5370\u72B6\u6001`,
    4020606: `\u64CD\u4F5C\u65E5\u5FD7`,
    4020607: `\u5237\u5355\u6807\u8BB0`,
    403: `\u5F02\u5E38\u8BA2\u5355`,
    40301: `\u540C\u6B65\u8BA2\u5355`,
    40302: `\u64CD\u4F5C\u65E5\u5FD7`,
    404: `\u8BA2\u5355\u65E5\u5FD7`,
    405: `\u8BA2\u5355\u8BBE\u7F6E`,
    40501: `\u53D1\u8D27\u89C4\u5219\u8BBE\u7F6E`,
    4050101: `\u65B0\u589E\u89C4\u5219`,
    4050102: `\u7F16\u8F91\u89C4\u5219`,
    4050103: `\u5220\u9664\u89C4\u5219`,
    40502: `\u53D1\u8D27\u4ED3\u8BBE\u7F6E`,
    4050201: `\u65B0\u589E\u89C4\u5219`,
    4050202: `\u7F16\u8F91\u89C4\u5219`,
    4050203: `\u542F\u7528\u89C4\u5219`,
    4050204: `\u505C\u7528\u89C4\u5219`,
    4050205: `\u67E5\u770B\u64CD\u4F5C\u65E5\u5FD7`,
    40503: `\u5FEB\u9012\u5355\u4FE1\u606F\u8BBE\u7F6E`,
    40504: `\u6A21\u677F\u8BBE\u7F6E`,
    4050401: `\u5FEB\u9012\u5355\u6A21\u677F\u8BBE\u7F6E`,
    4050402: `\u62E3\u8D27\u5355\u6A21\u677F\u8BBE\u7F6E`,
    4050403: `\u53D1\u7968\u6A21\u677F\u8BBE\u7F6E`,
    4050404: `\u88C5\u7BB1\u5355\u6A21\u677F\u8BBE\u7F6E`,
    40505: `\u5BFC\u51FA\u8BBE\u7F6E`,
    4050501: `\u65B0\u589E\u6A21\u677F`,
    4050502: `\u7F16\u8F91\u6A21\u677F`,
    4050503: `\u5220\u9664\u6A21\u677F`,
    40506: `LA\u53D1\u7968\u89C4\u5219\u8BBE\u7F6E`,
    4050601: `\u65B0\u589E\u89C4\u5219`,
    4050602: `\u7F16\u8F91\u89C4\u5219`,
    4050603: `\u5220\u9664\u89C4\u5219`,
    40507: `\u4F63\u91D1\u8BBE\u7F6E`,
    4050701: `\u7F16\u8F91\u4F63\u91D1`,
    40508: `\u914D\u8D27\u8BBE\u7F6E`,
    4050801: `\u64CD\u4F5C\u65E5\u5FD7`,
    406: `\u9000\u8D27\u7BA1\u7406`,
    40601: `\u9000\u6B3E\u5217\u8868`,
    4060101: `\u63A5\u53D7`,
    4060102: `\u62D2\u7EDD`,
    4060103: `\u540C\u6B65`,
    4060104: `\u67E5\u770B\u9000\u8D27\u65E5\u5FD7`,
    4060105: `\u540C\u610F\u9000\u6B3E`,
    4060106: `\u62D2\u7EDD\u9000\u6B3E`,
    4060107: `\u9000\u8D27\u5165\u5E93`,
    40602: `\u9000\u8D27\u9000\u6B3E`,
    4060201: `\u63A5\u53D7`,
    4060202: `\u62D2\u7EDD`,
    4060203: `\u540C\u6B65`,
    4060204: `\u67E5\u770B\u9000\u8D27\u65E5\u5FD7`,
    4060205: `\u540C\u610F\u9000\u6B3E`,
    4060206: `\u62D2\u7EDD\u9000\u6B3E`,
    4060207: `\u9000\u8D27\u5165\u5E93`,
    407: `\u5386\u53F2\u8BA2\u5355`,
    40701: `\u64CD\u4F5C\u65E5\u5FD7`,
    40702: `\u540C\u6B65\u8BA2\u5355`,
    40703: `\u5BFC\u51FA\u8BA2\u5355`,
    408: `\u5B9E\u7528\u5DE5\u5177`,
    40801: `\u626B\u63CF\u53D1\u8D27`,
    40802: `\u7206\u6B3E\u6253\u5355`,
    40207: `\u7206\u6B3E\u6253\u5355`,
    4020701: `\u8865\u6253\u5FEB\u9012\u5355`,
    409: `\u5F85\u5904\u7406`,
    40901: `\u5B89\u6392\u53D1\u8D27`,
    4090101: `\u6DFB\u52A0\u8D60\u54C1`,
    4090102: `\u64CD\u4F5C\u65E5\u5FD7`,
    4090103: `\u66F4\u6362\u4ED3\u5E93`,
    4090104: `\u66F4\u6362\u5546\u54C1`,
    4090105: `\u5237\u5355\u6807\u8BB0`,
    4090106: `\u6401\u7F6E`,
    4090107: `\u540C\u6B65\u8BA2\u5355`,
    4090108: `\u63A5\u53D7\u8BA2\u5355`,
    4090109: `\u53D6\u6D88\u8BA2\u5355`,
    4090110: `\u6253\u5370\u5FEB\u9012\u5355`,
    4090111: `\u6279\u91CF\u6253\u5370\u5FEB\u9012\u5355`,
    4090112: `\u6253\u5370\u62E3\u8D27\u5355`,
    4090113: `\u6253\u5370\u88C5\u7BB1\u5355`,
    4090114: `\u6253\u5370\u53D1\u7968`,
    4090115: `\u8BBE\u7F6E\u62E3\u8D27\u72B6\u6001`,
    4090116: `\u8BBE\u7F6E\u6253\u5305\u72B6\u6001`,
    4090117: `\u8BBE\u7F6E\u6253\u5370\u72B6\u6001`,
    4090118: `\u5B89\u6392\u53D1\u8D27`,
    4090119: `\u6253\u5305`,
    40902: `\u63A8\u9001\u4ED3\u5E93`,
    4090201: `\u6DFB\u52A0\u8D60\u54C1`,
    4090202: `\u64CD\u4F5C\u65E5\u5FD7`,
    4090203: `\u66F4\u6362\u4ED3\u5E93`,
    4090204: `\u66F4\u6362\u5546\u54C1`,
    4090205: `\u5237\u5355\u6807\u8BB0`,
    4090206: `\u6401\u7F6E`,
    4090207: `\u4E0B\u53D1\u4ED3\u5E93`,
    4090208: `\u6253\u5370\u5FEB\u9012\u5355`,
    4090209: `\u6279\u91CF\u6253\u5370\u5FEB\u9012\u5355`,
    4090210: `\u6253\u5370\u62E3\u8D27\u5355`,
    4090211: `\u6253\u5370\u88C5\u7BB1\u5355`,
    4090212: `\u6253\u5370\u53D1\u7968`,
    4090213: `\u8BBE\u7F6E\u62E3\u8D27\u72B6\u6001`,
    4090214: `\u8BBE\u7F6E\u6253\u5305\u72B6\u6001`,
    4090215: `\u8BBE\u7F6E\u6253\u5370\u72B6\u6001`,
    40903: `\u95EE\u9898\u8BA2\u5355`,
    4090301: `\u6DFB\u52A0\u8D60\u54C1`,
    4090302: `\u64CD\u4F5C\u65E5\u5FD7`,
    4090303: `\u66F4\u6362\u4ED3\u5E93`,
    4090304: `\u66F4\u6362\u5546\u54C1`,
    4090305: `\u5237\u5355\u6807\u8BB0`,
    4090306: `\u6401\u7F6E`,
    4090307: `\u6253\u5370\u5FEB\u9012\u5355`,
    4090308: `\u6279\u91CF\u6253\u5370\u5FEB\u9012\u5355`,
    4090309: `\u6253\u5370\u62E3\u8D27\u5355`,
    4090310: `\u6253\u5370\u88C5\u7BB1\u5355`,
    4090311: `\u6253\u5370\u53D1\u7968`,
    4090312: `\u8BBE\u7F6E\u62E3\u8D27\u72B6\u6001`,
    4090313: `\u8BBE\u7F6E\u6253\u5305\u72B6\u6001`,
    4090314: `\u8BBE\u7F6E\u6253\u5370\u72B6\u6001`,
    4090315: `\u91CD\u65B0\u914D\u8D27`,
    4090316: `\u540C\u6B65\u8BA2\u5355`,
    4090317: `\u5B89\u6392\u53D1\u8D27`,
    5: `\u4E3B\u5546\u54C1`,
    501: `\u4E3B\u5546\u54C1\u5217\u8868`,
    50101: `\u6DFB\u52A0\u5546\u54C1`,
    50102: `\u5BFC\u5165/\u5BFC\u51FA`,
    50103: `\u7F16\u8F91\u5546\u54C1\uFF08\u542B\u6279\u91CF\uFF09`,
    50104: `\u514B\u9686\u4E3B\u5546\u54C1\uFF08\u542B\u6279\u91CF\uFF09`,
    50105: `\u53D1\u5E03\u5230\u5E97\u94FA`,
    50106: `\u5220\u9664\u4E3B\u5546\u54C1`,
    50107: `\u6279\u91CF\u89E3\u7ED1`,
    50108: `\u6682\u4E0D\u5173\u6CE8`,
    50109: `\u590D\u5236\u4E3B\u5546\u54C1`,
    50201: `\u5BFC\u5165/\u5BFC\u51FA`,
    502: `\u4EF7\u683C\u7BA1\u7406`,
    50202: `\u540C\u6B65\u6D3B\u52A8`,
    503: `\u5546\u54C1\u8BBE\u7F6E`,
    50301: `\u4E3B\u5546\u54C1\u8BBE\u7F6E`,
    5030101: `\u81EA\u52A8\u7ED1\u5B9A\u4E3BSKU`,
    5030102: `\u81EA\u52A8\u521B\u5EFA\u4E3BSKU`,
    50302: `\u6DFB\u52A0\u5546\u54C1\u8BBE\u7F6E`,
    50303: `\u514B\u9686\u8BBE\u7F6E`,
    50304: `\u5546\u54C1\u6D3B\u8DC3\u5EA6\u8BBE\u7F6E`,
    50305: `\u6761\u7801\u6253\u5370\u6A21\u677F\u8BBE\u7F6E`,
    6: `\u6E20\u9053\u5546\u54C1`,
    601: `\u5546\u54C1\u5217\u8868`,
    60101: `\u65B0\u589E\u5546\u54C1`,
    60102: `\u4FEE\u6539\u5E93\u5B58`,
    60103: `\u7F16\u8F91\u5546\u54C1`,
    60104: `\u514B\u9686\u5546\u54C1`,
    60105: `\u540C\u6B65\u5546\u54C1`,
    60106: `\u5220\u9664\u5546\u54C1`,
    60107: `\u4E0A\u67B6\u5546\u54C1`,
    60108: `\u4E0B\u67B6\u5546\u54C1`,
    60109: `\u6279\u91CF\u53D1\u5E03`,
    60110: `\u6279\u91CF\u7F16\u8F91`,
    60111: `\u6279\u91CF\u5220\u9664`,
    60112: `\u6279\u91CF\u514B\u9686`,
    60113: `\u6279\u91CF\u4E0A\u67B6`,
    60114: `\u6279\u91CF\u4E0B\u67B6`,
    60115: `\u5546\u54C1\u5BFC\u5165/\u5BFC\u51FA`,
    60116: `\u751F\u6210\u4E3B\u5546\u54C1`,
    602: `\u5546\u54C1\u5DE5\u5177`,
    60201: `\u5546\u54C1\u91C7\u96C6`,
    6020101: `\u91C7\u96C6\u5217\u8868`,
    6020102: `\u4E00\u952E\u91C7\u96C6`,
    60202: `\u5E97\u94FA\u642C\u5BB6`,
    7: `\u5E93\u5B58`,
    701: `\u5E93\u5B58\u7BA1\u7406`,
    70101: `ISKU\u5217\u8868`,
    70102: `\u5BFC\u51FA\u6216\u5BFC\u5165ISKU\u6570\u636E`,
    70103: `\u65B0\u589EISKU`,
    70104: `\u7F16\u8F91ISKU`,
    70105: `\u5220\u9664ISKU`,
    70106: `\u4FEE\u6539ISKU\u5E93\u5B58`,
    70107: `\u5E93\u5B58\u53D8\u66F4\u8BB0\u5F55`,
    710: `\u9884\u7559\u5E93\u5B58`,
    702: `\u5E93\u5B58\u6E05\u5355`,
    70213: `\u5BFC\u51FA`,
    70214: `\u5BFC\u5165`,
    70202: `\u7F16\u8F91\u4ED3\u5E93\u5E93\u5B58`,
    70204: `\u63A8\u9001\u5E93\u5B58`,
    70206: `\u4FEE\u6539\u5E73\u5747\u91C7\u8D2D\u5355\u4EF7`,
    70207: `\u8BBE\u7F6E\u5907\u7528\u5E93\u5B58`,
    70208: `\u7F16\u8F91`,
    70209: `\u6DFB\u52A0\u5546\u54C1\u5230\u4ED3\u5E93`,
    70210: `\u5B89\u5168\u5E93\u5B58\u8BBE\u7F6E`,
    70211: `\u90AE\u7BB1\u63D0\u9192\u8BBE\u7F6E`,
    70212: `\u5E93\u5B58\u9884\u8B66`,
    70215: `\u5220\u9664`,
    70216: `\u9690\u85CF\u5E73\u5747\u91C7\u8D2D\u4EF7`,
    703: `\u5E93\u5B58\u53D8\u66F4\u8BB0\u5F55`,
    704: `\u63A8\u9001\u8BB0\u5F55`,
    705: `\u5E93\u5B58\u62C9\u53D6\u8BB0\u5F55`,
    707: `\u5E93\u5B58\u63A8\u9001\u89C4\u5219`,
    708: `\u5E93\u5B58\u63A8\u9001\u89C4\u5219`,
    70801: `\u6DFB\u52A0\u89C4\u5219`,
    70802: `\u4E3B\u5E97\u94FA\u5E93\u5B58\u9501\u5B9A`,
    70803: `\u6267\u884C\u89C4\u5219`,
    70804: `\u7F16\u8F91`,
    70805: `\u5220\u9664`,
    70806: `\u5F00\u542F/\u5173\u95ED`,
    709: `\u5E97\u94FA\u63A8\u9001\u8BB0\u5F55`,
    706: `\u5E93\u5B58\u8BBE\u7F6E`,
    70601: `\u5E93\u5B58\u76D1\u63A7\u4E0E\u540C\u6B65`,
    70602: `\u4E3B\u5E97\u94FA\u5E93\u5B58\u9501\u5B9A`,
    8: `\u4ED3\u5E93`,
    801: `\u4ED3\u5E93\u5217\u8868`,
    802: `\u8D27\u67B6\u7BA1\u7406`,
    804: `\u51FA\u5E93\u7BA1\u7406`,
    80401: `\u67E5\u770B`,
    80402: `\u64CD\u4F5C`,
    805: `\u5165\u5E93\u7BA1\u7406`,
    80501: `\u67E5\u770B`,
    80502: `\u64CD\u4F5C`,
    806: `\u51FA\u5165\u5E93\u8BB0\u5F55`,
    807: `\u4E09\u65B9\u4ED3\u5E93\u5B58\u62C9\u53D6`,
    809: `WMS \u4ED3\u5E93`,
    80901: `\u5546\u54C1\u4FE1\u606F`,
    810: `Accurate \u4ED3\u5E93`,
    81001: `\u5546\u54C1\u63A8\u9001\u8BB0\u5F55`,
    81002: `\u8BA2\u5355\u63A8\u9001\u8BB0\u5F55`,
    811: `\u5E93\u5B58\u76D8\u70B9`,
    81101: `\u65B0\u589E`,
    81102: `\u5BFC\u51FA/\u5BFC\u5165`,
    81103: `\u5F00\u59CB\u76D8\u70B9`,
    81104: `\u7F16\u8F91`,
    81105: `\u5220\u9664`,
    81106: `\u7EE7\u7EED\u76D8\u70B9`,
    81107: `\u7ED3\u675F\u76D8\u70B9`,
    81108: `\u4F5C\u5E9F`,
    81109: `\u6253\u5370\u76D8\u70B9\u5355`,
    81110: `\u751F\u6210\u5E93\u5B58\u8C03\u6574\u5355`,
    81111: `\u521B\u5EFA\u76D8\u70B9\u5355`,
    812: `\u8C03\u6574\u5355`,
    81201: `\u5F00\u59CB\u8C03\u6574`,
    81202: `\u4F5C\u5E9F`,
    81203: `\u7EE7\u7EED\u8C03\u6574`,
    81204: `\u786E\u8BA4\u8C03\u6574`,
    81205: `\u6574\u5355\u8C03\u6574`,
    81206: `\u65E0\u9700\u8C03\u6574`,
    813: `Keeppack \u4ED3\u5E93`,
    81301: `\u5546\u54C1\u4FE1\u606F`,
    8130101: `\u7ED1\u5B9AMSKU`,
    8130102: `\u62C9\u53D6\u5546\u54C1`,
    8130103: `\u521B\u5EFA\u4E3B\u5546\u54C1`,
    8130104: `\u914D\u7F6E\u7BA1\u7406`,
    8130105: `\u89E3\u7ED1MSKU`,
    81302: `\u5165\u5E93\u7BA1\u7406`,
    8130201: `\u63A8\u9001`,
    8130202: `\u4F5C\u5E9F`,
    8130203: `\u65B0\u589E`,
    81303: `\u51FA\u5E93\u7BA1\u7406`,
    8130301: `\u63A8\u9001`,
    8130302: `\u4F5C\u5E9F`,
    81304: `\u5E93\u5B58\u62C9\u53D6\u8BB0\u5F55`,
    814: `KONGFU \u4ED3\u5E93`,
    81401: `\u5546\u54C1\u4FE1\u606F`,
    8140101: `\u7ED1\u5B9AMSKU`,
    8140102: `\u62C9\u53D6\u5546\u54C1`,
    8140103: `\u521B\u5EFA\u4E3B\u5546\u54C1`,
    8140104: `\u914D\u7F6E\u7BA1\u7406`,
    8140105: `\u89E3\u7ED1MSKU`,
    81402: `\u5165\u5E93\u7BA1\u7406`,
    8140201: `\u63A8\u9001`,
    8140202: `\u4F5C\u5E9F`,
    8140203: `\u521B\u5EFA\u5165\u5E93\u5355`,
    81403: `\u51FA\u5E93\u7BA1\u7406`,
    8140301: `\u63A8\u9001`,
    8140302: `\u4F5C\u5E9F`,
    81404: `\u5E93\u5B58\u62C9\u53D6\u8BB0\u5F55`,
    9: `\u4FC3\u9500`,
    901: `\u6298\u6263\u7BA1\u7406`,
    90101: `\u6298\u6263\u5217\u8868`,
    9010101: `\u540C\u6B65\u6D3B\u52A8`,
    9010102: `\u65B0\u589E\u6D3B\u52A8`,
    9010103: `\u6279\u91CF\u65B0\u589E\u6D3B\u52A8`,
    9010104: `\u6D3B\u52A8\u8BE6\u60C5`,
    9010105: `\u7F16\u8F91\u6D3B\u52A8`,
    9010106: `\u5220\u9664\u6D3B\u52A8`,
    9010107: `\u6279\u91CF\u5220\u9664\u6D3B\u52A8`,
    9010108: `\u6682\u505C\u6D3B\u52A8`,
    9010109: `\u5BFC\u5165\u6D3B\u52A8`,
    9010110: `\u6A21\u7248\u6279\u91CF\u521B\u5EFA`,
    9010111: `\u67E5\u770B\u6279\u91CF\u6DFB\u52A0\u5386\u53F2`,
    90102: `\u6298\u6263\u6A21\u677F`,
    9010201: `\u65B0\u589E\u6A21\u677F`,
    9010202: `\u7F16\u8F91\u6A21\u677F`,
    9010203: `\u5220\u9664\u6A21\u677F`,
    902: `\u81EA\u52A8\u7F6E\u9876`,
    90201: `\u7F16\u8F91\u7F6E\u9876\u4FE1\u606F`,
    90202: `\u7F16\u8F91\u5E97\u94FA\u72B6\u6001`,
    90203: `\u65B0\u589E\u7F6E\u9876\u5546\u54C1`,
    90204: `\u79FB\u9664\u7F6E\u9876\u5546\u54C1`,
    90205: `\u8BBE\u7F6E\u7F6E\u9876\u89C4\u5219`,
    10: `\u5BA2\u6237`,
    1001: `\u5BA2\u6237\u5217\u8868`,
    100101: `\u5BFC\u51FA\u9009\u4E2D\u5BA2\u6237`,
    100102: `\u5BFC\u51FA\u5168\u90E8\u5BA2\u6237`,
    100103: `\u67E5\u770B\u5BFC\u51FA\u5386\u53F2`,
    100104: `\u65B0\u589E\u5BA2\u6237`,
    100105: `\u5BFC\u5165\u5BA2\u6237`,
    100106: `\u7F16\u8F91\u5BA2\u6237`,
    100107: `\u5220\u9664\u5BA2\u6237`,
    100108: `\u67E5\u770B\u5BA2\u6237`,
    100109: `\u8BBE\u7F6E\u5BA2\u6237\u5206\u7EC4`,
    100110: `\u8BBE\u7F6E\u4E3A\u9ED1\u540D\u5355`,
    1002: `\u5BA2\u6237\u5206\u7EC4`,
    100201: `\u65B0\u589E\u5206\u7EC4`,
    100202: `\u7F16\u8F91\u5206\u7EC4`,
    100203: `\u5220\u9664\u5206\u7EC4`,
    11: `\u62A5\u8868`,
    1101: `\u9500\u552E\u62A5\u8868`,
    110101: `\u8BA2\u5355\u7EDF\u8BA1\u8868`,
    11010101: `\u5BFC\u51FA\u62A5\u8868`,
    11010102: `\u67E5\u770B\u5BFC\u51FA\u5386\u53F2`,
    110102: `\u5546\u54C1\u9500\u552E\u7EDF\u8BA1\u8868`,
    110107: `\u4E3B\u5546\u54C1\u9500\u91CF\u7EDF\u8BA1`,
    110108: `\u4E3B\u5546\u54C1\u6D3B\u8DC3\u5EA6`,
    11010201: `\u5BFC\u51FA\u62A5\u8868`,
    11010202: `\u67E5\u770B\u5BFC\u51FA\u5386\u53F2`,
    110103: `\u5546\u54C1\u89C4\u683C\u9500\u552E\u7EDF\u8BA1\u8868`,
    11010301: `\u5BFC\u51FA\u62A5\u8868`,
    11010302: `\u67E5\u770B\u5BFC\u51FA\u5386\u53F2`,
    110104: `\u5E73\u53F0\u9500\u552E\u7EDF\u8BA1\u8868`,
    11010401: `\u5BFC\u51FA\u62A5\u8868`,
    11010402: `\u67E5\u770B\u5BFC\u51FA\u5386\u53F2`,
    110105: `\u5E97\u94FA\u9500\u552E\u7EDF\u8BA1\u8868`,
    11010501: `\u5BFC\u51FA\u62A5\u8868`,
    11010502: `\u67E5\u770B\u5BFC\u51FA\u5386\u53F2`,
    110106: `\u5229\u6DA6\u8868(\u6709\u201C\u5E93\u5B58\u6E05\u5355\u201D\u6743\u9650\u65F6\u53EF\u7528)`,
    11010601: `\u5BFC\u51FA\u4E3AExcel`,
    11010602: `\u5BFC\u51FA\u4E3APDF`,
    11010603: `\u67E5\u770B\u5BFC\u51FA\u5386\u53F2`,
    1102: `\u5E93\u5B58\u62A5\u8868`,
    110203: `\u5E93\u5B58\u4EF7\u503C`,
    110201: `\u7F3A\u8D27\u9884\u6D4B\u8868`,
    11020101: `\u53BB\u8865\u8D27`,
    11020102: `\u5BFC\u51FA\u62A5\u8868`,
    11020103: `\u67E5\u770B\u5BFC\u51FA\u5386\u53F2`,
    110202: `\u6EDE\u9500\u7EDF\u8BA1\u8868`,
    11020201: `\u5BFC\u51FA\u62A5\u8868`,
    11020202: `\u67E5\u770B\u5BFC\u51FA\u5386\u53F2`,
    11020203: `\u81EA\u5B9A\u4E49`,
    12: `\u6388\u6743`,
    1201: `\u5E97\u94FA\u5217\u8868`,
    120101: `\u7F16\u8F91\u5E97\u94FA\u4FE1\u606F`,
    120102: `\u65AD\u5F00\u94FE\u63A5`,
    120103: `\u6DFB\u52A0\u5E97\u94FA`,
    120104: `\u4ED3\u5E93\u7BA1\u7406`,
    120105: `\u786E\u8BA4\u6388\u6743`,
    120106: `\u62C9\u53D6\u4ED3\u5E93`,
    120107: `\u7ED1\u5B9A`,
    120108: `\u66F4\u65B0`,
    120109: `\u64CD\u4F5C\u65E5\u5FD7`,
    1202: `\u6DFB\u52A0\u6388\u6743`,
    14: `\u804A\u5929`,
    1405: `windows\u7248\u4E0B\u8F7D\u6309\u94AE`,
    1406: `macos\u7248\u4E0B\u8F7D\u6309\u94AE`,
    1401: `\u804A\u5929\u5BA4\u7BA1\u7406`,
    1402: `\u5F00\u901A\u804A\u5929\u5BA4`,
    1403: `\u505C\u7528\u804A\u5929\u5BA4`,
    1404: `\u81EA\u52A8\u767B\u5F55\u8BBE\u7F6E`,
    15: `\u8BBE\u7F6E`,
    1501: `\u57FA\u7840\u8BBE\u7F6E`,
    1502: `\u5546\u54C1\u8BBE\u7F6E`,
    1503: `\u8BA2\u5355\u8BBE\u7F6E`,
    1504: `\u5E93\u5B58\u8BBE\u7F6E`,
    1505: `\u7269\u6D41\u8BBE\u7F6E`,
    150501: `\u7269\u6D41\u8BBE\u7F6E\u5217\u8868`,
    150502: `\u8BBE\u7F6E\u7269\u6D41\u5F00\u5173`,
    1506: `\u5458\u5DE5\u7BA1\u7406`,
    150601: `\u5458\u5DE5\u5217\u8868`,
    150602: `\u65B0\u589E\u5458\u5DE5`,
    150603: `\u7F16\u8F91\u5458\u5DE5`,
    150604: `\u5220\u9664\u5458\u5DE5`,
    1507: `\u89D2\u8272\u7BA1\u7406`,
    150701: `\u89D2\u8272\u5217\u8868`,
    150702: `\u65B0\u589E\u89D2\u8272`,
    150703: `\u67E5\u770B\u89D2\u8272`,
    150704: `\u7F16\u8F91\u89D2\u8272`,
    150705: `\u5220\u9664\u89D2\u8272`,
    1508: `\u5C65\u7EA6\u4ED3\u8BBE\u7F6E`,
    150801: `JD\u5C65\u7EA6\u670D\u52A1`,
    15080101: `\u65B0\u589E\u90E8\u95E8`,
    150802: `Fastock\u5C65\u7EA6\u670D\u52A1`,
    15080201: `\u65B0\u589E\u4ED3\u5E93`,
    150803: `Ginee\u5C65\u7EA6\u670D\u52A1`,
    15080301: `\u65B0\u589E\u4ED3\u5E93`,
    1509: `\u91CD\u8BBE\u5BC6\u7801`,
    16: `\u7269\u6D41`,
    1601: `\u67E5\u8BE2\u8FD0\u8D39`,
    808: `\u4E09\u65B9\u4ED3\u5546\u54C1\u5217\u8868`,
    80801: `\u540C\u6B65`,
    80802: `\u521B\u5EFA\u4E3B\u5546\u54C1`,
    80803: `\u7ED1\u5B9A\u8BB0\u5F55`,
    80804: `\u540C\u6B65\u4ED3\u5E93\u5546\u54C1`,
    80805: `\u7ED1\u5B9AMSKU`,
    80806: `\u89E3\u7ED1MSKU`,
    18: `\u91C7\u8D2D`,
    1801: `\u4F9B\u5E94\u5546\u7BA1\u7406`,
    180101: `\u67E5\u770B`,
    180102: `\u64CD\u4F5C`,
    1802: `\u91C7\u8D2D\u8BA2\u5355`,
    180201: `\u67E5\u770B`,
    180202: `\u64CD\u4F5C`,
    180203: `\u5BFC\u51FA`
  },
  id: {
    noData: `tidak ada data`,
    allPermissions: `Semua izin`,
    1: `Paket Ginee`,
    101: `Akun & Paket Saat Ini`,
    102: `Harga Paket`,
    2: `SinkronisasiToko`,
    3: `Dasbor`,
    4: `Pesanan`,
    401: `Pesanan 90 hari terakhir`,
    40101: `Export Pesanan`,
    40103: `Sinkronisasi Pesanan`,
    40104: `Terima Pesanan`,
    40105: `Batalkan Pesanan`,
    40106: `Terima Pembatalan`,
    40107: `Kemas`,
    40108: `Atur Pengiriman`,
    40109: `Update Massal Ke Menunggu Dikirim`,
    40110: `Cetak Label Pengiriman`,
    40111: `Cetak Massal Label`,
    40112: `Cetak Daftar Ambil`,
    40113: `Cetak Packing List`,
    40114: `Cetak Invoice`,
    40115: `Lihat selengkapnya`,
    40116: `Tandai telah selesai`,
    40117: `Atur status pengambilan`,
    40118: `Atur status pengemasan`,
    40119: `Atur status cetak`,
    40120: `Atur catatan pengambilan`,
    40121: `Atur catatan penjual`,
    40122: `Catatan Operasi`,
    40123: `Pindah ke Dikirim`,
    40124: `Tambah Pesanan`,
    4012401: `Pesanan Referensi`,
    4012402: `Pilih pelanggan`,
    4012403: `Tambah Produk`,
    40125: `Impor Pesanan`,
    40126: `Pindah Ke Dikembalikan`,
    40127: `Edit pesanan`,
    40128: `Inbound Barang Retur`,
    40129: `Atur Siap Dikirim`,
    40130: `Ganti Gudang`,
    40131: `Ganti Produk`,
    40132: `Tambahkan Hadiah`,
    40133: `Tandai sebagai pesanan palsu`,
    402: `Proses Pesanan`,
    40201: `Tertunda`,
    4020101: `Pesanan Diproses`,
    4020102: `Batalkan Pesanan`,
    4020103: `Push gudang untuk pengiriman`,
    4020104: `Sisihkan`,
    4020105: `Periksa Stok`,
    4020106: `Ganti Master SKU`,
    4020107: `Export Pesanan`,
    4020108: `Sinkronisasi Pesanan`,
    4020109: `Atur Pengiriman`,
    4020110: `Terima Pesanan`,
    4020111: `Kemas`,
    4020112: `Cetak Label Pengiriman`,
    4020113: `Cetak Massal Label`,
    4020114: `Cetak Daftar Ambil`,
    4020115: `Cetak Packing List`,
    4020116: `Cetak Invoice`,
    4020117: `Atur status pengambilan`,
    4020118: `Atur status pengemasan`,
    4020119: `Atur status cetak`,
    4020120: `Catatan Operasi`,
    4020121: `Distribusikan Ulang`,
    4020122: `Gudang Pengiriman`,
    4020123: `Ganti Gudang`,
    4020124: `Ganti Produk`,
    4020125: `Tambahkan Hadiah`,
    4020126: `Tandai sebagai pesanan palsu`,
    40202: `Menunggu Dicetak`,
    4020201: `Cetak Label Pengiriman`,
    4020202: `Cetak Massal Label`,
    4020203: `Cetak Packing List`,
    4020204: `Cetak Daftar Ambil`,
    4020205: `Sinkronisasi Pesanan`,
    4020206: `Pindah ke Menunggu Pengumpulan`,
    4020207: `Pindah ke Dikirim`,
    4020208: `Export Pemesanan`,
    4020209: `Atur Status Pemngambilan`,
    4020210: `Atur Status Kemas`,
    4020211: `Atur Status Cetak`,
    4020212: `Catatan Operasi`,
    4020213: `Sisihkan`,
    4020214: `Batalkan Pesanan`,
    4020215: `Ganti Gudang`,
    4020216: `Ganti Produk`,
    4020217: `Tambahkan Hadiah`,
    4020218: `Tandai sebagai pesanan palsu`,
    4020219: `Atur Pengiriman`,
    40203: `Menunggu Dikumpulkan`,
    4020301: `Cetak Label Pengiriman`,
    4020302: `Cetak Massal Label`,
    4020303: `Cetak Packing List`,
    4020304: `Ceta kDaftar Ambil`,
    4020305: `Sinkronisasi Pesanan`,
    4020306: `Pindah ke Dikirim`,
    4020307: `Export Pesanan`,
    4020308: `Atur status pengambilan`,
    4020309: `Atur status pengemasan`,
    4020310: `Atur status cetak`,
    4020311: `Catatan Operasi`,
    4020312: `Cetak Invoice`,
    4020313: `Tandai sebagai pesanan palsu`,
    40204: `Dikirim`,
    4020401: `Cetak Label Pengiriman`,
    4020402: `Cetak Massal Label`,
    4020403: `Cetak Packing List`,
    4020404: `Cetak Daftar Ambil`,
    4020405: `Sinkronisasi Pesanan`,
    4020406: `Pindah ke Dikirim`,
    4020407: `Export Pesanan`,
    4020408: `Atur status pengambilan`,
    4020409: `Atur status pengemasan`,
    4020410: `Atur status cetak`,
    4020411: `Catatan Operasi`,
    4020412: `Tandai sebagai pesanan palsu`,
    40206: `Telah Disisihkan`,
    4020601: `Sinkronisasi Pesanan`,
    4020602: `Export Pesanan`,
    4020603: `Atur status pengambilan`,
    4020604: `Atur status pengemasan`,
    4020605: `Atur status cetak`,
    4020606: `Catatan Operasi`,
    4020607: `Tandai sebagai pesanan palsu`,
    403: `Pesanan tidak normal`,
    40301: `Sinkronisasi Pesanan`,
    40302: `Catatan Operasi`,
    404: `Log Pesanan`,
    405: `PengaturanPesanan`,
    40501: `Pengaturan Aturan Pengiriman`,
    4050101: `Tambahkan Aturan Baru`,
    4050102: `Ubah Aturan`,
    4050103: `Hapus Aturan`,
    40502: `Pengaturan Gudang Pengiriman`,
    4050201: `Tambahkan Aturan Baru`,
    4050202: `Ubah Aturan`,
    4050203: `Aktifkan Aturan`,
    4050204: `Non-aktifkan Aturan`,
    4050205: `Lihat Log Operasi`,
    40503: `Pengaturan Informasi Label Pengiriman`,
    40504: `Pengaturan Template`,
    4050401: `Pengaturan Template Label Pengiriman`,
    4050402: `Pengaturan Template Daftar Ambil`,
    4050403: `Pengaturan Template Invoice`,
    4050404: `Pengaturan Template Daftar Pengemasan`,
    40505: `Pengaturan Eksport`,
    4050501: `Template Baru`,
    4050502: `Edit Template`,
    4050503: `Hapus Template`,
    40506: `Pengaturan Aturan Invoice LA`,
    4050601: `Tambahkan Aturan Baru`,
    4050602: `Ubah Aturan`,
    4050603: `Hapus Aturan`,
    40507: `Pengaturan Komisi`,
    4050701: `Edit Komisi`,
    40508: `Pengaturan Distribusi`,
    4050801: `Catatan Operasi`,
    406: `Manajemen Retur`,
    40601: `Pengembalian Dana`,
    4060101: `Terima`,
    4060102: `Tolak`,
    4060103: `Sinkronkan`,
    4060104: `Lihat Riwayat Pengembalian`,
    4060105: `Terima Pengembalian Dana`,
    4060106: `Tolak Pengembalian Dana`,
    4060107: `Inbound Barang Retur`,
    40602: `Retur Barang & Dana`,
    4060201: `Terima`,
    4060202: `Tolak`,
    4060203: `Sinkronkan`,
    4060204: `Lihat Riwayat Pengembalian`,
    4060205: `Terima Pengembalian Dana`,
    4060206: `Tolak Pengembalian Dana`,
    4060207: `Inbound Barang Retur`,
    407: `Riwayat Pesanan`,
    40701: `Catatan Operasi`,
    40702: `Sinkronisasi Pesanan`,
    40703: `Export Pesanan`,
    408: `Utilitas`,
    40801: `Pindai pengiriman`,
    40802: `Cetak Label Hot Item`,
    40207: `Cetak Label Hot Item`,
    4020701: `Cetak label tambahan`,
    409: `Tertunda`,
    40901: `Atur Pengiriman`,
    4090101: `Tambahkan Hadiah`,
    4090102: `Catatan Operasi`,
    4090103: `Ganti Gudang`,
    4090104: `Ganti Produk`,
    4090105: `Tandai sebagai pesanan palsu`,
    4090106: `Sisihkan`,
    4090107: `Sinkronisasi Pesanan`,
    4090108: `Terima Pesanan`,
    4090109: `Batalkan Pesanan`,
    4090110: `Cetak Label Pengiriman`,
    4090111: `Cetak Massal Label`,
    4090112: `Cetak Daftar Ambil`,
    4090113: `Cetak Packing List`,
    4090114: `Cetak Invoice`,
    4090115: `Atur status pengambilan`,
    4090116: `Atur status pengemasan`,
    4090117: `Atur status cetak`,
    4090118: `Atur Pengiriman`,
    4090119: `Kemas`,
    40902: `Push Gudang`,
    4090201: `Tambahkan Hadiah`,
    4090202: `Catatan Operasi`,
    4090203: `Ganti Gudang`,
    4090204: `Ganti Produk`,
    4090205: `Tandai sebagai pesanan palsu`,
    4090206: `Sisihkan`,
    4090207: `Gudang Pengiriman`,
    4090208: `Cetak Label Pengiriman`,
    4090209: `Cetak Massal Label`,
    4090210: `Cetak Daftar Ambil`,
    4090211: `Cetak Packing List`,
    4090212: `Cetak Invoice`,
    4090213: `Atur status pengambilan`,
    4090214: `Atur status pengemasan`,
    4090215: `Atur status cetak`,
    40903: `Pesanan Bermasalah`,
    4090301: `Tambahkan Hadiah`,
    4090302: `Catatan Operasi`,
    4090303: `Ganti Gudang`,
    4090304: `Ganti Produk`,
    4090305: `Tandai sebagai pesanan palsu`,
    4090306: `Sisihkan`,
    4090307: `Cetak Label Pengiriman`,
    4090308: `Cetak Massal Label`,
    4090309: `Cetak Daftar Ambil`,
    4090310: `Cetak Packing List`,
    4090311: `Cetak Invoice`,
    4090312: `Atur status pengambilan`,
    4090313: `Atur status pengemasan`,
    4090314: `Atur status cetak`,
    4090315: `Distribusikan Ulang`,
    4090316: `Sinkronisasi Pesanan`,
    4090317: `Atur Pengiriman`,
    5: `Master Produk`,
    501: `Daftar Master Produk`,
    50101: `Tambah Produk`,
    50102: `Import/Eksport`,
    50103: `Edit Produk(termasuk masal)`,
    50104: `Salin Master Product (termasuk massal)`,
    50105: `Tampilkan ke toko`,
    50106: `Hapus Master Product`,
    50107: `Lepasi katan secara massal`,
    50108: `Tidak Terlacak`,
    50109: `Salin Master Produk`,
    50201: `Import/Eksport`,
    502: `Manajemen Harga`,
    50202: `Sinkronkan Promosi`,
    503: `Pengaturan Produk`,
    50301: `Pengaturan Master Produk`,
    5030101: `Otomatis Ikat MSKU`,
    5030102: `Otomatis Buat MSKU`,
    50302: `Pengaturan Tambah Produk`,
    50303: `Pengaturan Salin`,
    50304: `Pengaturan Aktifitas Produk`,
    50305: `Barcode Printing Template Settings`,
    6: `Produk Channel`,
    601: `Daftar Produk`,
    60101: `Tambah Produk`,
    60102: `Edit Stok`,
    60103: `Edit Produk`,
    60104: `Salin Produk`,
    60105: `Sinkronisasi Produk`,
    60106: `Hapus Produk`,
    60107: `Produk Aktif`,
    60108: `Produk Nonaktif`,
    60109: `Tampilkan Massal`,
    60110: `EditMassal`,
    60111: `Hapus Massal`,
    60112: `Salin Massal`,
    60113: `Aktifkan Massal`,
    60114: `Nonaktifkan Massal`,
    60115: `Impor/Ekspor Produk`,
    60116: `Buat Master Produk`,
    602: `Tools Produk`,
    60201: `Scrape Produk`,
    6020101: `Daftar Scrape`,
    6020102: `Scrape Sekali Klik`,
    60202: `Salin Toko`,
    7: `Stok`,
    701: `Manajemen Stok`,
    70101: `Daftar ISKU`,
    70102: `Ekspor/Impor Data ISKU`,
    70103: `Tambah ISKU`,
    70104: `Edit ISKU`,
    70105: `Hapus ISKU`,
    70106: `Ubah Stok ISKU`,
    70107: `Riwayat Perubahan Stok`,
    710: `Stock yang Direserve`,
    702: `Daftar Stok`,
    70213: `Export`,
    70214: `Import`,
    70202: `Ubah Stok Gudang`,
    70204: `Push Stok`,
    70206: `Mengubah harga satuan pembelian rata-rata`,
    70207: `Set Stok Cadangan`,
    70208: `Ubah`,
    70209: `Tambah Produk ke Gudang`,
    70210: `Pengaturan Stok Pengaman`,
    70211: `Pengaturan Notifikasi Email`,
    70212: `Peringatan Stok`,
    70215: `Hapus`,
    70216: `Sembunyikan Harga Pembelian Rata-rata`,
    703: `Riwayat Perubahan Stok`,
    704: `Riwayat Edit Stok Toko`,
    705: `Riwayat Push Stok`,
    707: `Aturan Push Stok`,
    708: `Aturan Push Stok`,
    70801: `Tambahkan Aturan`,
    70802: `Stok Toko Utama Terkunci`,
    70803: `Jalankan Aturan`,
    70804: `Edit`,
    70805: `Hapus`,
    70806: `Enable/Nonaktifkan`,
    709: `Riwayat Push Stok`,
    706: `Pengaturan Stok`,
    70601: `Monitor Stok dan Sinkronisasi`,
    70602: `Kunci Stok Toko Utama`,
    8: `Gudang`,
    801: `Daftar Gudang`,
    802: `Manajemen Rak`,
    804: `Manajemen Outbound`,
    80401: `Lihat`,
    80402: `Atur`,
    805: `Manajemen Inbound`,
    80501: `Lihat`,
    80502: `Atur`,
    806: `Riwayat Stok Masuk/Keluar`,
    807: `Penarikan Stok Gudang Pihak Ketiga`,
    809: `WMS`,
    80901: `Informasi Produk`,
    810: `Gudang Accurate`,
    81001: `Catatan Push Produk`,
    81002: `Catatan Push Pesanan`,
    811: `Stok Opname`,
    81101: `Tambahkan`,
    81102: `Export/Import`,
    81103: `Mulai inventaris`,
    81104: `Edit`,
    81105: `Hapus`,
    81106: `Lanjutkan mengambil stok`,
    81107: `Selesai Stock Opname`,
    81108: `Set sebagai invalid`,
    81109: `Cetak Daftar Stock Opname`,
    81110: `Buat Daftar Penyesuaian Saham`,
    81111: `Buat Daftar Stock Opname`,
    812: `Penyesuaian stok`,
    81201: `Mulai menyesuaikan`,
    81202: `Set sebagai invalid`,
    81203: `Terus sesuaikan`,
    81204: `Konfirmasikan penyesuaian`,
    81205: `Penyesuaian tunggal menyeluruh`,
    81206: `Tidak diperlukan penyesuaian`,
    813: `Gudang keeppack`,
    81301: `Info Produk`,
    8130101: `Mengikat MSKU`,
    8130102: `Tarik produk`,
    8130103: `Buat Master Produk`,
    8130104: `Manajemen Konfigurasi`,
    8130105: `Lepas Ikatan MSKU`,
    81302: `Manajemen Inbound`,
    8130201: `Push`,
    8130202: `Set sebagai invalid`,
    8130203: `Buat Daftar Inbound`,
    81303: `Manajemen Outbound`,
    8130301: `Push`,
    8130302: `Set sebagai invalid`,
    81304: `Catatan tarik saham`,
    814: `Gudang KONGFU`,
    81401: `Info Produk`,
    8140101: `Mengikat MSKU`,
    8140102: `Tarik produk`,
    8140103: `Buat Master Produk`,
    8140104: `Manajemen Konfigurasi`,
    8140105: `Lepas Ikatan MSKU`,
    81402: `Manajemen Inbound`,
    8140201: `Push`,
    8140202: `Set sebagai invalid`,
    8140203: `Buat Daftar Inbound`,
    81403: `Manajemen Outbound`,
    8140301: `Push`,
    8140302: `Set sebagai invalid`,
    81404: `Catatan tarik saham`,
    9: `Promosi`,
    901: `Manajemen Diskon`,
    90101: `Daftar Diskon`,
    9010101: `Sinkronkan Promosi`,
    9010102: `Tambah Promosi`,
    9010103: `Tambah Promosi Massal`,
    9010104: `Detail Promosi`,
    9010105: `Edit Promosi`,
    9010106: `Hapus Promosi`,
    9010107: `Hapus Promosi Massal`,
    9010108: `Hentikan Sementara Promosi`,
    9010109: `Import Promosi`,
    9010110: `Buat masal dengan template`,
    9010111: `Lihat Riwayat Tambah Massal`,
    90102: `Template Promosi`,
    9010201: `Template Baru`,
    9010202: `Edit Template`,
    9010203: `Hapus Template`,
    902: `Naikkan Produk Otomatis`,
    90201: `Edit Informasi Naikan Produk`,
    90202: `Edit Status Toko`,
    90203: `Tambah Naikan Produk`,
    90204: `Hapus Naikan Produk`,
    90205: `Atur Aturan Boosting`,
    10: `Pelanggan`,
    1001: `Daftar Pelanggan`,
    100101: `Export Pelanggan yang Dipilih`,
    100102: `Export Seluruh Pelanggan`,
    100103: `Lihat Riwayar Export`,
    100104: `Tambahkan Pelanggan`,
    100105: `Import Pelanggan`,
    100106: `Edit Pelanggan`,
    100107: `Hapus Pelanggan`,
    100108: `Lihat Pelanggan`,
    100109: `Edit Grup Pelanggan`,
    100110: `Set sebagai blacklist`,
    1002: `Grup Pelanggan`,
    100201: `Tambah Grup`,
    100202: `Edit Grup`,
    100203: `Hapus Grup`,
    11: `Laporan`,
    1101: `Laporan Penjualan`,
    110101: `Laporan Pesanan`,
    11010101: `Eksport Laporan`,
    11010102: `Lihat Riwayat Export`,
    110102: `Laporan Penjualan Produk`,
    110107: `Penjualan Master Produk`,
    110108: `Aktifitas Master Produk`,
    11010201: `Eksport Laporan`,
    11010202: `Lihat Riwayat Export`,
    110103: `Laporan Penjualan Variasi Produk`,
    11010301: `Eksport Laporan`,
    11010302: `Lihat Riwayar Export`,
    110104: `Laporan Penjualan Channel`,
    11010401: `Eksport Laporan`,
    11010402: `Lihat Riwayat Export`,
    110105: `Laporan Penjualan Toko`,
    11010501: `Eksport Laporan`,
    11010502: `Lihat Riwayat Export`,
    110106: `Laporan Laba Rugi (Tersedia dengan izin "DaftarStok")`,
    11010601: `Export ke Excel`,
    11010602: `Export ke PDF`,
    11010603: `Lihat Riwayat Export`,
    1102: `Laporan Inventaris`,
    110203: `Nilai Stok`,
    110201: `Estimasi Stok Habis`,
    11020101: `Mengisi Ulang Stok`,
    11020102: `Eksport Laporan`,
    11020103: `Lihat Riwayat Export`,
    110202: `Tabel Statistik Produk Tidak Laku`,
    11020201: `Eksport Laporan`,
    11020202: `Lihat Riwayat Export`,
    11020203: `Custom`,
    12: `Integrasi`,
    1201: `DaftarToko`,
    120101: `Edit Info Toko`,
    120102: `Lepas Ikatan`,
    120103: `Tambah Toko`,
    120104: `Manajemen Gudang`,
    120105: `Konfirmasi Integrasi`,
    120106: `Tarik Gudang`,
    120107: `Ikatkan`,
    120108: `Perbarui`,
    120109: `Catatan Operasi`,
    1202: `Tambah Integrasi`,
    14: `Chat`,
    1405: `Unduh Windows Chat`,
    1406: `Unduh MacOS Chat`,
    1401: `Manajaemen Chat`,
    1402: `Aktifkan Chat`,
    1403: `Non-aktifkan Chat`,
    1404: `Pengaturan Auto Login`,
    15: `Pengaturan`,
    1501: `Pengaturan Dasar`,
    1502: `Pengaturan Produk`,
    1503: `Pengaturan Pesanan`,
    1504: `Pengaturan Stok`,
    1505: `Pengaturan Jasa Pengiriman`,
    150501: `Daftar Pengaturan Pengiriman`,
    150502: `Pengaturan On/Off Pengiriman`,
    1506: `Manajemen Staf`,
    150601: `Daftar Staf`,
    150602: `Tambah Staf`,
    150603: `Edit Staf`,
    150604: `Hapus Staf`,
    1507: `Pengaturan Peran`,
    150701: `Daftar Peran`,
    150702: `Tambahkan Peran Baru`,
    150703: `Lihat Peran`,
    150704: `Edit Peran`,
    150705: `Hapus Peran`,
    1508: `Pengaturan Fulfillment`,
    150801: `Layanan Fulfillment JD`,
    15080101: `Tambah Departemen`,
    150802: `Layanan Fulfillment Fastock`,
    15080201: `Tambah Gudang`,
    150803: `Layanan Fulfillment Ginee`,
    15080301: `Tambah Gudang`,
    1509: `Atur Ulang password`,
    16: `Jasa Pengiriman`,
    1601: `Cek ongkos kirim`,
    808: `Daftar Produk Gudang Pihak Ketiga`,
    80801: `Sinkronisasi`,
    80802: `Buat Master Produk`,
    80803: `Catatan Pengikatan`,
    80804: `Sinkronkan Produk Gudang`,
    80805: `MSKU Terikat`,
    80806: `Lepas ikatan MSKU`,
    18: `Pembelian`,
    1801: `Manajemen Supplier`,
    180101: `Lihat`,
    180102: `Atur`,
    1802: `Pesanan Pembelian`,
    180201: `Lihat`,
    180202: `Atur`,
    180203: `Export`
  },
  th: {
    noData: `\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25`,
    allPermissions: `\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E22\u0E48\u0E2D\u0E22`,
    1: `\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08 Ginee`,
    101: `\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E41\u0E25\u0E30\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19`,
    102: `\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E41\u0E25\u0E30\u0E23\u0E32\u0E04\u0E32`,
    2: `\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    3: `\u0E41\u0E14\u0E0A\u0E1A\u0E2D\u0E23\u0E4C\u0E14`,
    4: `\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    401: `\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E40\u0E01\u0E37\u0E2D\u0E1A 90 \u0E27\u0E31\u0E19`,
    40101: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40103: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40104: `\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40105: `\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40106: `\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01`,
    40107: `\u0E41\u0E1E\u0E47\u0E04\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40108: `\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    40109: `\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E23\u0E2D\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    40110: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    40111: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    40112: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    40113: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2B\u0E35\u0E1A\u0E2B\u0E48\u0E2D`,
    40114: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    40115: `\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21`,
    40116: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19`,
    40117: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    40118: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E41\u0E1E\u0E47\u0E04\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    40119: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C`,
    40120: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    40121: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E39\u0E49\u0E02\u0E32\u0E22`,
    40122: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    40123: `\u0E22\u0E49\u0E32\u0E22\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E41\u0E25\u0E49\u0E27`,
    40124: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4012401: `\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E2D\u0E49\u0E32\u0E07\u0E2D\u0E34\u0E07`,
    4012402: `\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32`,
    4012403: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    40125: `\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40126: `\u0E22\u0E49\u0E32\u0E22\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E37\u0E19`,
    40127: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40128: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E37\u0E19\u0E40\u0E02\u0E49\u0E32\u0E04\u0E25\u0E31\u0E07`,
    40129: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    40130: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    40131: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    40132: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E02\u0E2D\u0E07\u0E2A\u0E21\u0E19\u0E32\u0E04\u0E38\u0E13`,
    40133: `\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E1B\u0E25\u0E2D\u0E21`,
    402: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40201: `\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    4020101: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020102: `\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020103: `\u0E14\u0E31\u0E19\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    4020104: `\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23`,
    4020105: `\u0E40\u0E0A\u0E47\u0E04\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    4020106: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19SKU\u0E2B\u0E25\u0E31\u0E01`,
    4020107: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020108: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020109: `\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    4020110: `\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020111: `\u0E41\u0E1E\u0E47\u0E04\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020112: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    4020113: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    4020114: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020115: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2B\u0E35\u0E1A\u0E2B\u0E48\u0E2D`,
    4020116: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020117: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020118: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E41\u0E1E\u0E47\u0E04\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020119: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C`,
    4020120: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    4020121: `\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07`,
    4020122: `\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    4020123: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020124: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020125: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E02\u0E2D\u0E07\u0E2A\u0E21\u0E19\u0E32\u0E04\u0E38\u0E13`,
    4020126: `\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E1B\u0E25\u0E2D\u0E21`,
    40202: `\u0E23\u0E2D\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020201: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    4020202: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    4020203: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2B\u0E35\u0E1A\u0E2B\u0E48\u0E2D`,
    4020204: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020205: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020206: `\u0E22\u0E49\u0E32\u0E22\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A\u0E41\u0E1E\u0E47\u0E01\u0E40\u0E01\u0E08`,
    4020207: `\u0E22\u0E49\u0E32\u0E22\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E41\u0E25\u0E49\u0E27`,
    4020208: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020209: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020210: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E41\u0E1E\u0E47\u0E04\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020211: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C`,
    4020212: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    4020213: `\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23`,
    4020214: `\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020215: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020216: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020217: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E02\u0E2D\u0E07\u0E2A\u0E21\u0E19\u0E32\u0E04\u0E38\u0E13`,
    4020218: `\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E1B\u0E25\u0E2D\u0E21`,
    4020219: `\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    40203: `\u0E17\u0E35\u0E48\u0E08\u0E30\u0E23\u0E31\u0E1A`,
    4020301: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    4020302: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    4020303: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2B\u0E35\u0E1A\u0E2B\u0E48\u0E2D`,
    4020304: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020305: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020306: `\u0E22\u0E49\u0E32\u0E22\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E41\u0E25\u0E49\u0E27`,
    4020307: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020308: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020309: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E41\u0E1E\u0E47\u0E04\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020310: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C`,
    4020311: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    4020312: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E19\u0E35\u0E49`,
    4020313: `\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E1B\u0E25\u0E2D\u0E21`,
    40204: `\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E41\u0E25\u0E49\u0E27`,
    4020401: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    4020402: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    4020403: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2B\u0E35\u0E1A\u0E2B\u0E48\u0E2D`,
    4020404: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020405: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020406: `\u0E22\u0E49\u0E32\u0E22\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E41\u0E25\u0E49\u0E27`,
    4020407: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020408: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020409: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E41\u0E1E\u0E47\u0E04\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020410: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C`,
    4020411: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    4020412: `\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E1B\u0E25\u0E2D\u0E21`,
    40206: `\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23`,
    4020601: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020602: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4020603: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020604: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E41\u0E1E\u0E47\u0E04\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4020605: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C`,
    4020606: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    4020607: `\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E1B\u0E25\u0E2D\u0E21`,
    403: `\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1B\u0E01\u0E15\u0E34`,
    40301: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40302: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    404: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    405: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40501: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E0E\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    4050101: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E0E`,
    4050102: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E01\u0E0E`,
    4050103: `\u0E25\u0E1A\u0E01\u0E0E`,
    40502: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    4050201: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E0E`,
    4050202: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E01\u0E0E`,
    4050203: `\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E0E`,
    4050204: `\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E0E`,
    4050205: `\u0E14\u0E39\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19`,
    40503: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    40504: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15`,
    4050401: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    4050402: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E43\u0E1A\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4050403: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4050404: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2B\u0E35\u0E1A\u0E2B\u0E48\u0E2D`,
    40505: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    4050501: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E43\u0E2B\u0E21\u0E48`,
    4050502: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15`,
    4050503: `\u0E25\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15`,
    40506: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E0E\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32LA`,
    4050601: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E0E`,
    4050602: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E01\u0E0E`,
    4050603: `\u0E25\u0E1A\u0E01\u0E0E`,
    40507: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19`,
    4050701: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19`,
    40508: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E40\u0E15\u0E34\u0E21\u0E40\u0E15\u0E47\u0E21`,
    4050801: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19`,
    406: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    40601: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19`,
    4060101: `\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A`,
    4060102: `\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18`,
    4060103: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D`,
    4060104: `\u0E14\u0E39\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E04\u0E37\u0E19`,
    4060105: `\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19`,
    4060106: `\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19`,
    4060107: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E37\u0E19\u0E40\u0E02\u0E49\u0E32\u0E04\u0E25\u0E31\u0E07`,
    40602: `\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 & \u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19`,
    4060201: `\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A`,
    4060202: `\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18`,
    4060203: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D`,
    4060204: `\u0E14\u0E39\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E04\u0E37\u0E19`,
    4060205: `\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19`,
    4060206: `\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19`,
    4060207: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E37\u0E19\u0E40\u0E02\u0E49\u0E32\u0E04\u0E25\u0E31\u0E07`,
    407: `\u0E04\u0E4D\u0E32\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E43\u0E19\u0E2D\u0E14\u0E35\u0E15`,
    40701: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19`,
    40702: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40703: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    408: `\u0E22\u0E39\u0E17\u0E34\u0E25\u0E34\u0E15\u0E35\u0E49`,
    40801: `\u0E2A\u0E41\u0E01\u0E19\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    40802: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E02\u0E32\u0E22\u0E14\u0E35`,
    40207: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E02\u0E32\u0E22\u0E14\u0E35`,
    4020701: `\u0E1B\u0E49\u0E32\u0E22\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21`,
    409: `\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    40901: `\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    4090101: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E02\u0E2D\u0E07\u0E2A\u0E21\u0E19\u0E32\u0E04\u0E38\u0E13`,
    4090102: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    4090103: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090104: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090105: `\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E1B\u0E25\u0E2D\u0E21`,
    4090106: `\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23`,
    4090107: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4090108: `\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4090109: `\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4090110: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    4090111: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    4090112: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090113: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2B\u0E35\u0E1A\u0E2B\u0E48\u0E2D`,
    4090114: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090115: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090116: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E41\u0E1E\u0E47\u0E04\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090117: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C`,
    4090118: `\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    4090119: `\u0E41\u0E1E\u0E47\u0E04\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    40902: `\u0E1C\u0E25\u0E31\u0E01\u0E14\u0E31\u0E19\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090201: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E02\u0E2D\u0E07\u0E2A\u0E21\u0E19\u0E32\u0E04\u0E38\u0E13`,
    4090202: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    4090203: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090204: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090205: `\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E1B\u0E25\u0E2D\u0E21`,
    4090206: `\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23`,
    4090207: `\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    4090208: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    4090209: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    4090210: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090211: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2B\u0E35\u0E1A\u0E2B\u0E48\u0E2D`,
    4090212: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090213: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090214: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E41\u0E1E\u0E47\u0E04\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090215: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C`,
    40903: `\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E17\u0E35\u0E48\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32`,
    4090301: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E02\u0E2D\u0E07\u0E2A\u0E21\u0E19\u0E32\u0E04\u0E38\u0E13`,
    4090302: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    4090303: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090304: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090305: `\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E1B\u0E25\u0E2D\u0E21`,
    4090306: `\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23`,
    4090307: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    4090308: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    4090309: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090310: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2B\u0E35\u0E1A\u0E2B\u0E48\u0E2D`,
    4090311: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090312: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2B\u0E22\u0E34\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090313: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E41\u0E1E\u0E47\u0E04\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    4090314: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C`,
    4090315: `\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07`,
    4090316: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    4090317: `\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    5: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    501: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    50101: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    50102: `\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E41\u0E25\u0E30\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    50103: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32(\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21)`,
    50104: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01 (\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21)`,
    50105: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    50106: `\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    50107: `\u0E40\u0E25\u0E34\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    50108: `\u0E44\u0E21\u0E48\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21`,
    50109: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    50201: `\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E41\u0E25\u0E30\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    502: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E23\u0E32\u0E04\u0E32`,
    50202: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    503: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    50301: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    5030101: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2DSKU\u0E2B\u0E25\u0E31\u0E01\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34`,
    5030102: `\u0E2A\u0E23\u0E49\u0E32\u0E07SKU\u0E2B\u0E25\u0E31\u0E01\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34`,
    50302: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    50303: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    50304: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E04\u0E27\u0E32\u0E21\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    50305: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E1A\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14`,
    6: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22`,
    601: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    60101: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    60102: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    60103: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    60104: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    60105: `\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    60106: `\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    60107: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    60108: `\u0E40\u0E25\u0E34\u0E01\u0E02\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    60109: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    60110: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    60111: `\u0E25\u0E1A\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    60112: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    60113: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    60114: `\u0E40\u0E25\u0E34\u0E01\u0E02\u0E32\u0E22\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    60115: `\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32/\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    60116: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    602: `\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E21\u0E37\u0E2D\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    60201: `\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    6020101: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01`,
    6020102: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E19\u0E04\u0E25\u0E34\u0E01\u0E40\u0E14\u0E35\u0E22\u0E27`,
    60202: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    7: `\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    701: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    70101: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 ISKU`,
    70102: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ISKU`,
    70103: `\u0E40\u0E1E\u0E34\u0E48\u0E21 ISKU`,
    70104: `\u0E41\u0E01\u0E49\u0E44\u0E02 ISKU`,
    70105: `\u0E25\u0E1A ISKU`,
    70106: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E15\u0E47\u0E2D\u0E01 ISKU`,
    70107: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    710: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E08\u0E2D\u0E07`,
    702: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    70213: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    70214: `\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32`,
    70202: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    70204: `\u0E14\u0E31\u0E19\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    70206: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E04\u0E32\u0E0B\u0E37\u0E49\u0E2D\u0E40\u0E09\u0E25\u0E35\u0E48\u0E22`,
    70207: `\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E33\u0E23\u0E2D\u0E07`,
    70208: `\u0E41\u0E01\u0E49\u0E44\u0E02`,
    70209: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    70210: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22`,
    70211: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25`,
    70212: `\u0E04\u0E33\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    70215: `\u0E25\u0E1A`,
    70216: `\u0E0B\u0E48\u0E2D\u0E19\u0E23\u0E32\u0E04\u0E32\u0E0B\u0E37\u0E49\u0E2D\u0E40\u0E09\u0E25\u0E35\u0E48\u0E22`,
    703: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    704: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E31\u0E19\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    705: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E36\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    707: `\u0E01\u0E0E\u0E01\u0E32\u0E23\u0E14\u0E31\u0E19\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    708: `\u0E01\u0E0E\u0E01\u0E32\u0E23\u0E14\u0E31\u0E19\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    70801: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E0E`,
    70802: `\u0E25\u0E47\u0E2D\u0E04\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    70803: `\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E15\u0E32\u0E21\u0E01\u0E0E`,
    70804: `\u0E41\u0E01\u0E49\u0E44\u0E02`,
    70805: `\u0E25\u0E1A`,
    70806: `\u0E40\u0E1B\u0E34\u0E14/\u0E1B\u0E34\u0E14`,
    709: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E1C\u0E25\u0E31\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    706: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    70601: `\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E41\u0E25\u0E30\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34`,
    70602: `\u0E25\u0E47\u0E2D\u0E04\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    8: `\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    801: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    802: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E0A\u0E31\u0E49\u0E19\u0E27\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    804: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E02\u0E32\u0E2D\u0E2D\u0E01`,
    80401: `\u0E14\u0E39`,
    80402: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    805: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E02\u0E32\u0E40\u0E02\u0E49\u0E32`,
    80501: `\u0E14\u0E39`,
    80502: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    806: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E40\u0E02\u0E49\u0E32/\u0E2D\u0E2D\u0E01`,
    807: `\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48 3 \u0E14\u0E36\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    809: `WMS`,
    80901: `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    810: `\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 Accurate`,
    81001: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E1C\u0E25\u0E31\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    81002: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E1C\u0E25\u0E31\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    811: `\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    81101: `\u0E40\u0E1E\u0E34\u0E48\u0E21`,
    81102: `\u0E19\u0E33\u0E2D\u0E2D\u0E01/\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32`,
    81103: `\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E07\u0E04\u0E25\u0E31\u0E07`,
    81104: `\u0E41\u0E01\u0E49\u0E44\u0E02`,
    81105: `\u0E25\u0E1A`,
    81106: `\u0E14\u0E4D\u0E32\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B`,
    81107: `\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    81108: `\u0E15\u0E31\u0E49\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30`,
    81109: `\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    81110: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E43\u0E1A\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    81111: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E43\u0E1A\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    812: `\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E01\u0E49\u0E02\u0E2D\u0E07\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E37\u0E48\u0E2D`,
    81201: `\u0E40\u0E23\u0E34\u0E48\u0E21\u0E1B\u0E23\u0E31\u0E1A`,
    81202: `\u0E15\u0E31\u0E49\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30`,
    81203: `\u0E1B\u0E23\u0E31\u0E1A\u0E44\u0E1B\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E22\u0E46`,
    81204: `\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A`,
    81205: `\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E04\u0E23\u0E31\u0E49\u0E07\u0E40\u0E14\u0E35\u0E22\u0E27\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    81206: `\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E23\u0E31\u0E1A\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19`,
    813: `\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 Keeppack`,
    81301: `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    8130101: `\u0E23\u0E27\u0E21 MSKU`,
    8130102: `\u0E14\u0E36\u0E07\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C`,
    8130103: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    8130104: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E04\u0E48\u0E32`,
    8130105: `\u0E40\u0E25\u0E34\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21 MSKU`,
    81302: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E43\u0E1A\u0E40\u0E02\u0E49\u0E32\u0E04\u0E25\u0E31\u0E07`,
    8130201: `\u0E1C\u0E25\u0E31\u0E01\u0E14\u0E31\u0E19`,
    8130202: `\u0E15\u0E31\u0E49\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30`,
    8130203: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E43\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    81303: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E43\u0E1A\u0E2D\u0E2D\u0E01\u0E04\u0E25\u0E31\u0E07`,
    8130301: `\u0E1C\u0E25\u0E31\u0E01\u0E14\u0E31\u0E19`,
    8130302: `\u0E15\u0E31\u0E49\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30`,
    81304: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E36\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    814: `\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 KONGFU`,
    81401: `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    8140101: `\u0E23\u0E27\u0E21 MSKU`,
    8140102: `\u0E14\u0E36\u0E07\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C`,
    8140103: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    8140104: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E04\u0E48\u0E32`,
    8140105: `\u0E40\u0E25\u0E34\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21 MSKU`,
    81402: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E43\u0E1A\u0E40\u0E02\u0E49\u0E32\u0E04\u0E25\u0E31\u0E07`,
    8140201: `\u0E1C\u0E25\u0E31\u0E01\u0E14\u0E31\u0E19`,
    8140202: `\u0E15\u0E31\u0E49\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30`,
    8140203: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E43\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    81403: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E43\u0E1A\u0E2D\u0E2D\u0E01\u0E04\u0E25\u0E31\u0E07`,
    8140301: `\u0E1C\u0E25\u0E31\u0E01\u0E14\u0E31\u0E19`,
    8140302: `\u0E15\u0E31\u0E49\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30`,
    81404: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E14\u0E36\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    9: `\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    901: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14`,
    90101: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14`,
    9010101: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    9010102: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    9010103: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    9010104: `\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    9010105: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    9010106: `\u0E25\u0E1A\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    9010107: `\u0E25\u0E1A\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    9010108: `\u0E2B\u0E22\u0E38\u0E14\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    9010109: `\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    9010110: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E14\u0E49\u0E27\u0E22\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15`,
    9010111: `\u0E14\u0E39\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    90102: `\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    9010201: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E43\u0E2B\u0E21\u0E48`,
    9010202: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15`,
    9010203: `\u0E25\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15`,
    902: `\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E17\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34`,
    90201: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E17\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    90202: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    90203: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E17`,
    90204: `\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E17`,
    90205: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E0E\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E17\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    10: `\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32`,
    1001: `\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32`,
    100101: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01`,
    100102: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    100103: `\u0E14\u0E39\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    100104: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32`,
    100105: `\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32`,
    100106: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32`,
    100107: `\u0E25\u0E1A\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32`,
    100108: `\u0E14\u0E39\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32`,
    100109: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E25\u0E38\u0E48\u0E21\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32`,
    100110: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E14\u0E33`,
    1002: `\u0E01\u0E25\u0E38\u0E48\u0E21\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32`,
    100201: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E25\u0E38\u0E48\u0E21\u0E43\u0E2B\u0E21\u0E48`,
    100202: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E01\u0E25\u0E38\u0E48\u0E21`,
    100203: `\u0E25\u0E1A\u0E01\u0E25\u0E38\u0E48\u0E21`,
    11: `\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19`,
    1101: `\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22`,
    110101: `\u0E2A\u0E16\u0E34\u0E15\u0E34\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    11010101: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19`,
    11010102: `\u0E14\u0E39\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    110102: `\u0E2A\u0E16\u0E34\u0E15\u0E34\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    110107: `\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    110108: `\u0E04\u0E27\u0E32\u0E21\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    11010201: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19`,
    11010202: `\u0E14\u0E39\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    110103: `\u0E2A\u0E16\u0E34\u0E15\u0E34\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E46`,
    11010301: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19`,
    11010302: `\u0E14\u0E39\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    110104: `\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E1A\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    11010401: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19`,
    11010402: `\u0E14\u0E39\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    110105: `\u0E2A\u0E16\u0E34\u0E15\u0E34\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    11010501: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19`,
    11010502: `\u0E14\u0E39\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    110106: `\u0E07\u0E1A\u0E01\u0E33\u0E44\u0E23\u0E02\u0E32\u0E14\u0E17\u0E38\u0E19(\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E01\u0E31\u0E1A "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32")`,
    11010601: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19Excel`,
    11010602: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19PDF`,
    11010603: `\u0E14\u0E39\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    1102: `\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    110203: `\u0E21\u0E39\u0E25\u0E04\u0E48\u0E32\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    110201: `\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\u0E01\u0E32\u0E23\u0E04\u0E32\u0E14\u0E40\u0E14\u0E32\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2B\u0E21\u0E14`,
    11020101: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    11020102: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19`,
    11020103: `\u0E14\u0E39\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    110202: `\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E22\u0E2D\u0E14\u0E02\u0E32\u0E22\u0E15\u0E48\u0E33`,
    11020201: `\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19`,
    11020202: `\u0E14\u0E39\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01`,
    11020203: `\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07`,
    12: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    1201: `\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    120101: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    120102: `\u0E40\u0E25\u0E34\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D`,
    120103: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    120104: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E04\u0E25\u0E31\u0E07`,
    120105: `\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E1C\u0E2A\u0E32\u0E19\u0E23\u0E27\u0E21`,
    120106: `\u0E14\u0E36\u0E07\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    120107: `\u0E1C\u0E39\u0E01`,
    120108: `\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15`,
    120109: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19`,
    1202: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D`,
    14: `\u0E41\u0E0A\u0E17`,
    1405: `\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 windows-chat`,
    1406: `\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 macos-chat`,
    1401: `\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E41\u0E0A\u0E17`,
    1402: `\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E0A\u0E17`,
    1403: `\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E0A\u0E17`,
    1404: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34`,
    15: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32`,
    1501: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19`,
    1502: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    1503: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    1504: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    1505: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    150501: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    150502: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14/\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    1506: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19`,
    150601: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19`,
    150602: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48`,
    150603: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19`,
    150604: `\u0E25\u0E1A\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19`,
    1507: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48`,
    150701: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48`,
    150702: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E21\u0E48`,
    150703: `\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48`,
    150704: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48`,
    150705: `\u0E25\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48`,
    1508: `\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    150801: `\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E42\u0E14\u0E22JD`,
    15080101: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E1C\u0E19\u0E01`,
    150802: `\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E42\u0E14\u0E22Fastock`,
    15080201: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    150803: `\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E42\u0E14\u0E22Ginee`,
    15080301: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    1509: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48`,
    16: `\u0E02\u0E19\u0E2A\u0E48\u0E07`,
    1601: `\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    808: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E25\u0E31\u0E07\u0E1D\u0E32\u0E01\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    80801: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D`,
    80802: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    80803: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D`,
    80804: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    80805: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21 MSKU`,
    80806: `\u0E40\u0E25\u0E34\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21 MSKU`,
    18: `\u0E0B\u0E37\u0E49\u0E2D`,
    1801: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E0B\u0E31\u0E1E\u0E1E\u0E25\u0E32\u0E22\u0E40\u0E2D\u0E2D\u0E23\u0E4C`,
    180101: `\u0E14\u0E39`,
    180102: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    1802: `\u0E43\u0E1A\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    180201: `\u0E14\u0E39`,
    180202: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    180203: `\u0E19\u0E33\u0E2D\u0E2D\u0E01`
  },
  vn: {
    noData: `Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u`,
    allPermissions: `Kh\xF4ng c\u1EA5p quy\u1EC1n`,
    1: `G\xF3i Ginee`,
    101: `T\xE0i kho\u1EA3n & G\xF3i`,
    102: `G\xF3i & Gi\xE1`,
    2: `\u0110\u1ED3ng b\u1ED9 C\u1EEDa h\xE0ng`,
    3: `T\u1ED5ng quan`,
    4: `\u0110\u01A1n h\xE0ng`,
    401: `\u0110\u01A1n \u0111\u1EB7t h\xE0ng g\u1EA7n 90 ng\xE0y`,
    40101: `Xu\u1EA5t \u0110\u01A1n h\xE0ng`,
    40103: `\u0110\u1ED3ng b\u1ED9 \u0110\u01A1n h\xE0ng`,
    40104: `Nh\u1EADn \u0110\u01A1n h\xE0ng`,
    40105: `H\u1EE7y \u0110\u01A1n h\xE0ng`,
    40106: `X\u1EED l\xFD \u0111\u01A1n h\u1EE7y`,
    40107: `\u0110\xF3ng g\xF3i`,
    40108: `S\u1EAFp x\u1EBFp giao h\xE0ng`,
    40109: `Th\xEAm v\xE0o ch\u1EDD giao h\xE0ng lo\u1EA1t`,
    40110: `In V\u1EADn \u0111\u01A1n`,
    40111: `In nhi\u1EC1u V\u1EADn \u0111\u01A1n`,
    40112: `In Phi\u1EBFu l\u1EA5y h\xE0ng`,
    40113: `In Phi\u1EBFu \u0111\xF3ng g\xF3i`,
    40114: `In H\xF3a \u0111\u01A1n`,
    40115: `Xem chi ti\u1EBFt`,
    40116: `\u0110\u1EB7t th\xE0nh \u0111\xE3 ho\xE0n t\u1EA5t`,
    40117: `\u0110\u1EB7t tr\u1EA1ng th\xE1i l\u1EA5y h\xE0ng`,
    40118: `\u0110\u1EB7t tr\u1EA1ng th\xE1i \u0111\xF3ng g\xF3i`,
    40119: `\u0110\u1EB7t tr\u1EA1ng th\xE1i in`,
    40120: `\u0110\u1EB7t ghi ch\xFA l\u1EA5y h\xE0ng`,
    40121: `\u0110\u1EB7t ghi ch\xFA nh\xE0 b\xE1n`,
    40122: `Ng\xE0y th\u1EF1c hi\u1EC7n`,
    40123: `Chuy\u1EC3n \u0111\u1EBFn \u0110\xE3 giao h\xE0ng`,
    40124: `Th\xEAm \u0111\u01A1n h\xE0ng m\u1EDBi`,
    4012401: `\u0110\u01A1n h\xE0ng tham kh\u1EA3o`,
    4012402: `Ch\u1ECDn kh\xE1ch h\xE0ng`,
    4012403: `Th\xEAm h\xE0ng`,
    40125: `Nh\u1EADp \u0111\u01A1n h\xE0ng`,
    40126: `Chuy\u1EC3n v\xE0o m\u1EE5c Ho\xE0n`,
    40127: `Ch\u1EC9nh s\u1EEDa \u0111\u01A1n h\xE0ng`,
    40128: `\u0110\u1EA9y h\xE0ng v\xE0o kho`,
    40129: `\u0110\u1EB7t th\xE0nh S\u1EB5n s\xE0ng g\u1EEDi`,
    40130: `Thay \u0111\u1ED5i kho h\xE0ng`,
    40131: `Thay \u0111\u1ED5i s\u1EA3n ph\u1EA9m`,
    40132: `Th\xEAm qu\xE0 t\u1EB7ng`,
    40133: `\u0110\xE1nh d\u1EA5u l\xE0 \u0111\u01A1n h\xE0ng \u1EA3o`,
    402: `X\u1EED l\xFD \u0110\u01A1n h\xE0ng`,
    40201: `Ch\u1EDD x\u1EED l\xFD`,
    4020101: `X\u1EED l\xFD \u0110\u01A1n h\xE0ng`,
    4020102: `H\u1EE7y \u0110\u01A1n h\xE0ng`,
    4020103: `\u0110\u1EA9y \u0111\u1EBFn kho g\u1EEDi h\xE0ng`,
    4020104: `G\xE1c l\u1EA1i`,
    4020105: `Ki\u1EC3m tra t\u1ED3n kho`,
    4020106: `Thay \u0111\u1ED5i Master SKU`,
    4020107: `Xu\u1EA5t \u0111\u01A1n h\xE0ng`,
    4020108: `\u0110\u1ED3ng b\u1ED9 \u0110\u01A1n h\xE0ng`,
    4020109: `S\u1EAFp x\u1EBFp giao h\xE0ng`,
    4020110: `Nh\u1EADn \u0110\u01A1n h\xE0ng`,
    4020111: `\u0110\xF3ng g\xF3i`,
    4020112: `In V\u1EADn \u0111\u01A1n`,
    4020113: `In nhi\u1EC1u V\u1EADn \u0111\u01A1n`,
    4020114: `In Phi\u1EBFu l\u1EA5y h\xE0ng`,
    4020115: `In Phi\u1EBFu \u0111\xF3ng g\xF3i`,
    4020116: `In H\xF3a \u0111\u01A1n`,
    4020117: `\u0110\u1EB7t tr\u1EA1ng th\xE1i l\u1EA5y h\xE0ng`,
    4020118: `\u0110\u1EB7t tr\u1EA1ng th\xE1i \u0111\xF3ng g\xF3i`,
    4020119: `\u0110\u1EB7t tr\u1EA1ng th\xE1i in`,
    4020120: `Ng\xE0y th\u1EF1c hi\u1EC7n`,
    4020121: `Ph\xE2n b\u1ED5 l\u1EA1i h\xE0ng h\xF3a`,
    4020122: `Kho giao h\xE0ng`,
    4020123: `Thay \u0111\u1ED5i kho h\xE0ng`,
    4020124: `Thay \u0111\u1ED5i s\u1EA3n ph\u1EA9m`,
    4020125: `Th\xEAm qu\xE0 t\u1EB7ng`,
    4020126: `\u0110\xE1nh d\u1EA5u l\xE0 \u0111\u01A1n h\xE0ng \u1EA3o`,
    40202: `\u0110\u01A1n h\xE0ng ch\u1EDD in`,
    4020201: `In V\u1EADn \u0111\u01A1n`,
    4020202: `In nhi\u1EC1u V\u1EADn \u0111\u01A1n`,
    4020203: `In Phi\u1EBFu \u0111\xF3ng g\xF3i`,
    4020204: `In Phi\u1EBFu l\u1EA5y h\xE0ng`,
    4020205: `\u0110\u1ED3ng b\u1ED9 \u0110\u01A1n h\xE0ng`,
    4020206: `Chuy\u1EC3n \u0111\u1EBFn Ch\u1EDD nh\u1EADn`,
    4020207: `Chuy\u1EC3n \u0111\u1EBFn \u0110\xE3 giao h\xE0ng`,
    4020208: `Xu\u1EA5t \u0110\u01A1n h\xE0ng`,
    4020209: `\u0110\u1EB7t tr\u1EA1ng th\xE1i l\u1EA5y h\xE0ng`,
    4020210: `\u0110\u1EB7t tr\u1EA1ng th\xE1i \u0111\xF3ng g\xF3i`,
    4020211: `\u0110\u1EB7t tr\u1EA1ng th\xE1i in`,
    4020212: `Ng\xE0y th\u1EF1c hi\u1EC7n`,
    4020213: `G\xE1c l\u1EA1i`,
    4020214: `H\u1EE7y \u0110\u01A1n h\xE0ng`,
    4020215: `Thay \u0111\u1ED5i kho h\xE0ng`,
    4020216: `Thay \u0111\u1ED5i s\u1EA3n ph\u1EA9m`,
    4020217: `Th\xEAm qu\xE0 t\u1EB7ng`,
    4020218: `\u0110\xE1nh d\u1EA5u l\xE0 \u0111\u01A1n h\xE0ng \u1EA3o`,
    4020219: `S\u1EAFp x\u1EBFp giao h\xE0ng`,
    40203: `Ch\u1EDD l\u1EA5y h\xE0ng`,
    4020301: `In V\u1EADn \u0111\u01A1n`,
    4020302: `In nhi\u1EC1u V\u1EADn \u0111\u01A1n`,
    4020303: `In Phi\u1EBFu \u0111\xF3ng g\xF3i`,
    4020304: `In Phi\u1EBFu l\u1EA5y h\xE0ng`,
    4020305: `\u0110\u1ED3ng b\u1ED9 \u0110\u01A1n h\xE0ng`,
    4020306: `Chuy\u1EC3n \u0111\u1EBFn \u0110\xE3 giao h\xE0ng`,
    4020307: `Xu\u1EA5t \u0110\u01A1n h\xE0ng`,
    4020308: `\u0110\u1EB7t tr\u1EA1ng th\xE1i l\u1EA5y h\xE0ng`,
    4020309: `\u0110\u1EB7t tr\u1EA1ng th\xE1i \u0111\xF3ng g\xF3i`,
    4020310: `\u0110\u1EB7t tr\u1EA1ng th\xE1i in`,
    4020311: `Ng\xE0y th\u1EF1c hi\u1EC7n`,
    4020312: `In h\xF3a \u0111\u01A1n`,
    4020313: `\u0110\xE1nh d\u1EA5u l\xE0 \u0111\u01A1n h\xE0ng \u1EA3o`,
    40204: `\u0110\xE3 giao h\xE0ng`,
    4020401: `In V\u1EADn \u0111\u01A1n`,
    4020402: `In nhi\u1EC1u V\u1EADn \u0111\u01A1n`,
    4020403: `In Phi\u1EBFu \u0111\xF3ng g\xF3i`,
    4020404: `In Phi\u1EBFu l\u1EA5y h\xE0ng`,
    4020405: `\u0110\u1ED3ng b\u1ED9 \u0110\u01A1n h\xE0ng`,
    4020406: `Chuy\u1EC3n \u0111\u1EBFn \u0110\xE3 giao h\xE0ng`,
    4020407: `Xu\u1EA5t \u0110\u01A1n h\xE0ng`,
    4020408: `\u0110\u1EB7t tr\u1EA1ng th\xE1i l\u1EA5y h\xE0ng`,
    4020409: `\u0110\u1EB7t tr\u1EA1ng th\xE1i \u0111\xF3ng g\xF3i`,
    4020410: `\u0110\u1EB7t tr\u1EA1ng th\xE1i in`,
    4020411: `Ng\xE0y th\u1EF1c hi\u1EC7n`,
    4020412: `\u0110\xE1nh d\u1EA5u l\xE0 \u0111\u01A1n h\xE0ng \u1EA3o`,
    40206: `\u0110\xE3 g\xE1c l\u1EA1i`,
    4020601: `\u0110\u1ED3ng b\u1ED9 \u0110\u01A1n h\xE0ng`,
    4020602: `Xu\u1EA5t \u0110\u01A1n h\xE0ng`,
    4020603: `\u0110\u1EB7t tr\u1EA1ng th\xE1i l\u1EA5y h\xE0ng`,
    4020604: `\u0110\u1EB7t tr\u1EA1ng th\xE1i \u0111\xF3ng g\xF3i`,
    4020605: `\u0110\u1EB7t tr\u1EA1ng th\xE1i in`,
    4020606: `Ng\xE0y th\u1EF1c hi\u1EC7n`,
    4020607: `\u0110\xE1nh d\u1EA5u l\xE0 \u0111\u01A1n h\xE0ng \u1EA3o`,
    403: `\u0110\u01A1n h\xE0ng b\u1EA5t th\u01B0\u1EDDng`,
    40301: `\u0110\u1ED3ng b\u1ED9 \u0110\u01A1n h\xE0ng`,
    40302: `Ng\xE0y th\u1EF1c hi\u1EC7n`,
    404: `Nh\u1EADt k\xFD \u0110\u01A1n h\xE0ng`,
    405: `C\xE0i \u0111\u1EB7t \u0110\u01A1n h\xE0ng`,
    40501: `\u0110\u1EB7t quy t\u1EAFc V\u1EADn chuy\u1EC3n`,
    4050101: `Quy t\u1EAFc Th\xEAm`,
    4050102: `Ch\u1EC9nh s\u1EEDa quy t\u1EAFc`,
    4050103: `X\xF3a quy t\u1EAFc`,
    40502: `C\xE0i \u0111\u1EB7t Kho giao h\xE0ng`,
    4050201: `Quy t\u1EAFc Th\xEAm`,
    4050202: `Ch\u1EC9nh s\u1EEDa quy t\u1EAFc`,
    4050203: `B\u1EADt quy t\u1EAFc`,
    4050204: `T\u1EAFt quy t\u1EAFc`,
    4050205: `Xem nh\u1EADt k\xFD ho\u1EA1t \u0111\u1ED9ng`,
    40503: `C\xE0i \u0111\u1EB7t Th\xF4ng tin V\u1EADn \u0111\u01A1n`,
    40504: `C\xE0i \u0111\u1EB7t M\u1EABu`,
    4050401: `C\xE0i \u0111\u1EB7t M\u1EABu V\u1EADn \u0111\u01A1n`,
    4050402: `C\xE0i \u0111\u1EB7t M\u1EABu Phi\u1EBFu l\u1EA5y h\xE0ng`,
    4050403: `C\xE0i \u0111\u1EB7t M\u1EABu H\xF3a \u0111\u01A1n`,
    4050404: `C\xE0i \u0111\u1EB7t M\u1EABu \u0110\xF3ng g\xF3i`,
    40505: `C\xE0i \u0111\u1EB7t Xu\u1EA5t`,
    4050501: `Th\xEAm M\u1EABu`,
    4050502: `Ch\u1EC9nh s\u1EEDa M\u1EABu`,
    4050503: `X\xF3a M\u1EABu`,
    40506: `C\xE0i \u0111\u1EB7t Quy t\u1EAFc H\xF3a \u0111\u01A1n LA`,
    4050601: `Quy t\u1EAFc Th\xEAm`,
    4050602: `Ch\u1EC9nh s\u1EEDa quy t\u1EAFc`,
    4050603: `X\xF3a quy t\u1EAFc`,
    40507: `C\xE0i \u0111\u1EB7t Hoa h\u1ED3ng`,
    4050701: `Ch\u1EC9nh s\u1EEDa Hoa h\u1ED3ng`,
    40508: `C\xE0i \u0111\u1EB7t fulfillment`,
    4050801: `Nh\u1EADt k\xFD ho\u1EA1t \u0111\u1ED9ng`,
    406: `Qu\u1EA3n l\xFD tr\u1EA3 h\xE0ng`,
    40601: `Danh s\xE1ch ho\xE0n ti\u1EC1n`,
    4060101: `Ch\u1EA5p nh\u1EADn`,
    4060102: `T\u1EEB ch\u1ED1i`,
    4060103: `\u0110\u1ED3ng b\u1ED9`,
    4060104: `Xem nh\u1EADt k\xFD tr\u1EA3 h\xE0ng`,
    4060105: `\u0110\u1ED3ng \xFD ho\xE0n ti\u1EC1n`,
    4060106: `T\u1EEB ch\u1ED1i ho\xE0n ti\u1EC1n`,
    4060107: `\u0110\u1EA9y h\xE0ng v\xE0o kho`,
    40602: `Tr\u1EA3 h\xE0ng v\xE0 ho\xE0n ti\u1EC1n`,
    4060201: `Ch\u1EA5p nh\u1EADn`,
    4060202: `T\u1EEB ch\u1ED1i`,
    4060203: `\u0110\u1ED3ng b\u1ED9`,
    4060204: `Xem nh\u1EADt k\xFD tr\u1EA3 h\xE0ng`,
    4060205: `\u0110\u1ED3ng \xFD ho\xE0n ti\u1EC1n`,
    4060206: `T\u1EEB ch\u1ED1i ho\xE0n ti\u1EC1n`,
    4060207: `\u0110\u1EA9y h\xE0ng v\xE0o kho`,
    407: `\u0110\u01A1n \u0111\u1EB7t h\xE0ng l\u1ECBch s\u1EED`,
    40701: `Nh\u1EADt k\xFD ho\u1EA1t \u0111\u1ED9ng`,
    40702: `\u0110\u1ED3ng b\u1ED9 \u0110\u01A1n h\xE0ng`,
    40703: `Xu\u1EA5t \u0110\u01A1n h\xE0ng`,
    408: `Ti\u1EC7n \xEDch`,
    40801: `Qu\xE9t l\xF4 h\xE0ng`,
    40802: `In \u0111\u01A1n b\xF9ng n\u1ED5`,
    40207: `In \u0111\u01A1n b\xF9ng n\u1ED5`,
    4020701: `In b\u1ED5 sung v\u1EADn \u0111\u01A1n`,
    409: `Ch\u1EDD x\u1EED l\xFD`,
    40901: `S\u1EAFp x\u1EBFp giao h\xE0ng`,
    4090101: `Th\xEAm qu\xE0 t\u1EB7ng`,
    4090102: `Ng\xE0y th\u1EF1c hi\u1EC7n`,
    4090103: `Thay \u0111\u1ED5i kho h\xE0ng`,
    4090104: `Thay \u0111\u1ED5i s\u1EA3n ph\u1EA9m`,
    4090105: `\u0110\xE1nh d\u1EA5u l\xE0 \u0111\u01A1n h\xE0ng \u1EA3o`,
    4090106: `G\xE1c l\u1EA1i`,
    4090107: `\u0110\u1ED3ng b\u1ED9 \u0110\u01A1n h\xE0ng`,
    4090108: `Nh\u1EADn \u0110\u01A1n h\xE0ng`,
    4090109: `H\u1EE7y \u0110\u01A1n h\xE0ng`,
    4090110: `In V\u1EADn \u0111\u01A1n`,
    4090111: `In nhi\u1EC1u V\u1EADn \u0111\u01A1n`,
    4090112: `In Phi\u1EBFu l\u1EA5y h\xE0ng`,
    4090113: `In Phi\u1EBFu \u0111\xF3ng g\xF3i`,
    4090114: `In H\xF3a \u0111\u01A1n`,
    4090115: `\u0110\u1EB7t tr\u1EA1ng th\xE1i l\u1EA5y h\xE0ng`,
    4090116: `\u0110\u1EB7t tr\u1EA1ng th\xE1i \u0111\xF3ng g\xF3i`,
    4090117: `\u0110\u1EB7t tr\u1EA1ng th\xE1i in`,
    4090118: `S\u1EAFp x\u1EBFp giao h\xE0ng`,
    4090119: `\u0110\xF3ng g\xF3i`,
    40902: `\u0110\u1EA9y kho h\xE0ng`,
    4090201: `Th\xEAm qu\xE0 t\u1EB7ng`,
    4090202: `Ng\xE0y th\u1EF1c hi\u1EC7n`,
    4090203: `Thay \u0111\u1ED5i kho h\xE0ng`,
    4090204: `Thay \u0111\u1ED5i s\u1EA3n ph\u1EA9m`,
    4090205: `\u0110\xE1nh d\u1EA5u l\xE0 \u0111\u01A1n h\xE0ng \u1EA3o`,
    4090206: `G\xE1c l\u1EA1i`,
    4090207: `Kho giao h\xE0ng`,
    4090208: `In V\u1EADn \u0111\u01A1n`,
    4090209: `In nhi\u1EC1u V\u1EADn \u0111\u01A1n`,
    4090210: `In Phi\u1EBFu l\u1EA5y h\xE0ng`,
    4090211: `In Phi\u1EBFu \u0111\xF3ng g\xF3i`,
    4090212: `In H\xF3a \u0111\u01A1n`,
    4090213: `\u0110\u1EB7t tr\u1EA1ng th\xE1i l\u1EA5y h\xE0ng`,
    4090214: `\u0110\u1EB7t tr\u1EA1ng th\xE1i \u0111\xF3ng g\xF3i`,
    4090215: `\u0110\u1EB7t tr\u1EA1ng th\xE1i in`,
    40903: `\u0110\u01A1n h\xE0ng c\xF3 v\u1EA5n \u0111\u1EC1`,
    4090301: `Th\xEAm qu\xE0 t\u1EB7ng`,
    4090302: `Ng\xE0y th\u1EF1c hi\u1EC7n`,
    4090303: `Thay \u0111\u1ED5i kho h\xE0ng`,
    4090304: `Thay \u0111\u1ED5i s\u1EA3n ph\u1EA9m`,
    4090305: `\u0110\xE1nh d\u1EA5u l\xE0 \u0111\u01A1n h\xE0ng \u1EA3o`,
    4090306: `G\xE1c l\u1EA1i`,
    4090307: `In V\u1EADn \u0111\u01A1n`,
    4090308: `In nhi\u1EC1u V\u1EADn \u0111\u01A1n`,
    4090309: `In Phi\u1EBFu l\u1EA5y h\xE0ng`,
    4090310: `In Phi\u1EBFu \u0111\xF3ng g\xF3i`,
    4090311: `In H\xF3a \u0111\u01A1n`,
    4090312: `\u0110\u1EB7t tr\u1EA1ng th\xE1i l\u1EA5y h\xE0ng`,
    4090313: `\u0110\u1EB7t tr\u1EA1ng th\xE1i \u0111\xF3ng g\xF3i`,
    4090314: `\u0110\u1EB7t tr\u1EA1ng th\xE1i in`,
    4090315: `Ph\xE2n b\u1ED5 l\u1EA1i h\xE0ng h\xF3a`,
    4090316: `\u0110\u1ED3ng b\u1ED9 \u0110\u01A1n h\xE0ng`,
    4090317: `S\u1EAFp x\u1EBFp giao h\xE0ng`,
    5: `S\u1EA3n ph\u1EA9m ch\xEDnh`,
    501: `Danh s\xE1ch S\u1EA3n ph\u1EA9m ch\xEDnh`,
    50101: `Th\xEAm S\u1EA3n ph\u1EA9m`,
    50102: `Nh\u1EADp/Xu\u1EA5t`,
    50103: `Ch\u1EC9nh s\u1EEDa S\u1EA3n ph\u1EA9m(\u0111\u01A1n/\u0111a)`,
    50104: `Sao ch\xE9p SP ch\xEDnh (\u0111\u01A1n/\u0111a)`,
    50105: `\u0110\u0103ng l\xEAn C\u1EEDa h\xE0ng`,
    50106: `X\xF3a s\u1EA3n ph\u1EA9m ch\xEDnh`,
    50107: `H\u1EE7y li\xEAn k\u1EBFt H\xE0ng lo\u1EA1t`,
    50108: `T\u1EA1m d\u1EEBng Theo d\xF5i`,
    50109: `Sao ch\xE9p`,
    50201: `Nh\u1EADp/Xu\u1EA5t`,
    502: `Qu\u1EA3n l\xFD Gi\xE1 b\xE1n`,
    50202: `\u0110\u1ED3ng b\u1ED9 Khuy\u1EBFn m\xE3i`,
    503: `C\xE0i \u0111\u1EB7t S\u1EA3n ph\u1EA9m`,
    50301: `C\xE0i \u0111\u1EB7t S\u1EA3n ph\u1EA9m ch\xEDnh`,
    5030101: `T\u1EF1 \u0111\u1ED9ng Li\xEAn k\u1EBFt MSKU`,
    5030102: `T\u1EF1 \u0111\u1ED9ng T\u1EA1o MSKU`,
    50302: `Th\xEAm C\xE0i \u0111\u1EB7t S\u1EA3n ph\u1EA9m`,
    50303: `C\xE0i \u0111\u1EB7t sao ch\xE9p`,
    50304: `C\xE0i \u0111\u1EB7t ho\u1EA1t \u0111\u1ED9ng s\u1EA3n ph\u1EA9m`,
    50305: `C\xE0i \u0111\u1EB7t m\u1EABu in m\xE3 v\u1EA1ch`,
    6: `S\u1EA3n ph\u1EA9m s\xE0n TM\u0110T`,
    601: `Danh s\xE1ch s\u1EA3n ph\u1EA9m`,
    60101: `Th\xEAm s\u1EA3n ph\u1EA9m`,
    60102: `Ch\u1EC9nh s\u1EEDa T\u1ED3n kho`,
    60103: `Ch\u1EC9nh s\u1EEDa S\u1EA3n ph\u1EA9m`,
    60104: `Sao ch\xE9p S\u1EA3n ph\u1EA9m`,
    60105: `\u0110\u1ED3ng b\u1ED9 S\u1EA3n ph\u1EA9m`,
    60106: `X\xF3a S\u1EA3n ph\u1EA9m`,
    60107: `\u0110ang b\xE1n`,
    60108: `Ng\u01B0ng b\xE1n`,
    60109: `\u0110\u0103ng H\xE0ng lo\u1EA1t`,
    60110: `Ch\u1EC9nh s\u1EEDa H\xE0ng lo\u1EA1t`,
    60111: `X\xF3a h\xE0ng lo\u1EA1t`,
    60112: `Sao ch\xE9p H\xE0ng lo\u1EA1t`,
    60113: `\u0110\u0103ng b\xE1n H\xE0ng lo\u1EA1t`,
    60114: `Ng\u01B0ng b\xE1n H\xE0ng lo\u1EA1t`,
    60115: `Nh\u1EADp/Xu\u1EA5t S\u1EA3n ph\u1EA9m`,
    60116: `T\u1EA1o S\u1EA3n ph\u1EA9m ch\xEDnh`,
    602: `C\xF4ng c\u1EE5`,
    60201: `Thu th\u1EADp S\u1EA3n ph\u1EA9m`,
    6020101: `B\u1ED9 s\u01B0u t\u1EADp`,
    6020102: `Thu th\u1EADp b\u1EB1ng 1 nh\u1EA5n`,
    60202: `Chuy\u1EC3n c\u1EEDa h\xE0ng`,
    7: `T\u1ED3n kho`,
    701: `Qu\u1EA3n l\xFD T\u1ED3n kho`,
    70101: `Danh s\xE1ch ISKU`,
    70102: `Nh\u1EADp/Xu\u1EA5t s\u1ED1 li\u1EC7u ISKU`,
    70103: `Th\xEAm ISKU`,
    70104: `Ch\u1EC9nh s\u1EEDa ISKU`,
    70105: `X\xF3a ISKU`,
    70106: `Ch\u1EC9nh s\u1EEDa T\u1ED3n kho ISKU`,
    70107: `L\u1ECBch s\u1EED bi\u1EBFn \u0111\u1ED9ng T\u1ED3n kho`,
    710: `h\xE0ng d\u1EF1 tr\u1EEF`,
    702: `Qu\u1EA3n l\xFD T\u1ED3n kho`,
    70213: `Xu\u1EA5t`,
    70214: `Nh\u1EADp`,
    70202: `Ch\u1EC9nh s\u1EEDa T\u1ED5ng t\u1ED3n kho`,
    70204: `\u0110\u1EA9y T\u1ED3n kho`,
    70206: `Ch\u1EC9nh s\u1EEDa \u0110\u01A1n gi\xE1 Mua h\xE0ng B\xECnh qu\xE2n`,
    70207: `Thi\u1EBFt l\u1EADp T\u1ED3n kho d\u1EF1 ph\xF2ng`,
    70208: `Ch\u1EC9nh s\u1EEDa`,
    70209: `Th\xEAm S\u1EA3n ph\u1EA9m v\xE0o Kho`,
    70210: `C\xE0i \u0111\u1EB7t T\u1ED3n kho An to\xE0n`,
    70211: `C\xE0i \u0111\u1EB7t Email nh\u1EAFc nh\u1EDF`,
    70212: `C\u1EA3nh b\xE1o T\u1ED3n kho`,
    70215: `X\xF3a`,
    70216: `\u1EA8n gi\xE1 mua trung b\xECnh`,
    703: `L\u1ECBch s\u1EED bi\u1EBFn \u0111\u1ED9ng T\u1ED3n kho`,
    704: `L\u1ECBch s\u1EED \u0111\u1EA9y`,
    705: `L\u1ECBch s\u1EED k\xE9o T\u1ED3n kho`,
    707: `Quy t\u1EAFc \u0111\u1EA9y T\u1ED3n kho`,
    708: `Quy t\u1EAFc \u0111\u1EA9y T\u1ED3n kho`,
    70801: `Th\xEAm quy t\u1EAFc`,
    70802: `Kh\xF3 t\u1ED3n kho c\u1EEDa h\xE0ng ch\xEDnh`,
    70803: `Th\u1EF1c thi quy t\u1EAFc`,
    70804: `Ch\u1EC9nh s\u1EEDa`,
    70805: `X\xF3a`,
    70806: `K\xEDch ho\u1EA1t/\u0110\xF3ng`,
    709: `Nh\u1EADt k\xFD \u0111\u1EA9y c\u1EE7a c\u1EEDa h\xE0ng`,
    706: `C\xE0i \u0111\u1EB7t T\u1ED3n kho`,
    70601: `Gi\xE1m s\xE1t & \u0110\u1ED3ng b\u1ED9 T\u1ED3n kho`,
    70602: `Kh\xF3a T\u1ED3n kho C\u1EEDa h\xE0ng ch\xEDnh`,
    8: `Kho h\xE0ng`,
    801: `Danh s\xE1ch kho`,
    802: `Qu\u1EA3n l\xFD K\u1EC7 h\xE0ng`,
    804: `Qu\u1EA3n l\xFD Xu\u1EA5t kho`,
    80401: `Xem`,
    80402: `Thao t\xE1c`,
    805: `Qu\u1EA3n l\xFD Nh\u1EADp kho`,
    80501: `Xem`,
    80502: `Thao t\xE1c`,
    806: `L\u1ECBch s\u1EED Xu\u1EA5t Nh\u1EADp kho`,
    807: `Danh s\xE1ch ki\u1EC3m k\xEA kho b\xEAn th\u1EE9 3`,
    809: `WMS`,
    80901: `Th\xF4ng tin s\u1EA3n ph\u1EA9m`,
    810: `Kho h\xE0ng Accurate`,
    81001: `Nh\u1EADt k\xFD \u0111\u1EA9y s\u1EA3n ph\u1EA9m`,
    81002: `Nh\u1EADt k\xFD \u0111\u1EA9y \u0111\u01A1n h\xE0ng`,
    811: `Ki\u1EC3m k\xEA T\u1ED3n kho`,
    81101: `Th\xEAm`,
    81102: `Xu\u1EA5t/Nh\u1EADp`,
    81103: `B\u1EAFt \u0111\u1EA7u ki\u1EC3m k\xEA`,
    81104: `Ch\u1EC9nh s\u1EEDa`,
    81105: `X\xF3a`,
    81106: `Ti\u1EBFp t\u1EE5c ki\u1EC3m k\xEA`,
    81107: `K\u1EBFt th\xFAc ki\u1EC3m k\xEA`,
    81108: `V\xF4 hi\u1EC7u`,
    81109: `In \u0111\u01A1n ki\u1EC3m k\xEA`,
    81110: `T\u1EA1o danh s\xE1ch \u0111i\u1EC1u ch\u1EC9nh kho`,
    81111: `T\u1EA1o \u0111\u01A1n ki\u1EC3m k\xEA`,
    812: `Ch\u1EC9nh di\u1EC7n kho`,
    81201: `B\u1EAFt \u0111\u1EA7u \u0111i\u1EC1u ch\u1EC9nh`,
    81202: `V\xF4 hi\u1EC7u`,
    81203: `Ti\u1EBFp t\u1EE5c \u0111i\u1EC1u ch\u1EC9nh`,
    81204: `X\xE1c nh\u1EADn \u0111i\u1EC1u ch\u1EC9nh`,
    81205: `\u0110i\u1EC1u ch\u1EC9nh phi\u1EBFu \u0111\u01A1n l\u1EBB`,
    81206: `Kh\xF4ng c\u1EA7n \u0111i\u1EC1u ch\u1EC9nh`,
    813: `Kho Keeppack`,
    81301: `Th\xF4ng tin m\u1EE5c`,
    8130101: `Li\xEAn k\u1EBFt MSKU`,
    8130102: `K\xE9o s\u1EA3n ph\u1EA9m`,
    8130103: `T\u1EA1o s\u1EA3n ph\u1EA9m ch\xEDnh`,
    8130104: `Qu\u1EA3n l\xFD c\u1EA5u h\xECnh`,
    8130105: `H\u1EE7y li\xEAn k\u1EBFt MSKU`,
    81302: `Qu\u1EA3n l\xFD Phi\u1EBFu nh\u1EADp kho`,
    8130201: `\u0110\u1EA9y`,
    8130202: `V\xF4 hi\u1EC7u`,
    8130203: `T\u1EA1o Phi\u1EBFu nh\u1EADp kho`,
    81303: `Qu\u1EA3n l\xFD Phi\u1EBFu xu\u1EA5t kho`,
    8130301: `\u0110\u1EA9y`,
    8130302: `V\xF4 hi\u1EC7u`,
    81304: `Th\xE0nh t\xEDch k\xE9o kho`,
    814: `Kho KONGFU`,
    81401: `Th\xF4ng tin m\u1EE5c`,
    8140101: `Li\xEAn k\u1EBFt MSKU`,
    8140102: `K\xE9o s\u1EA3n ph\u1EA9m`,
    8140103: `T\u1EA1o s\u1EA3n ph\u1EA9m ch\xEDnh`,
    8140104: `Qu\u1EA3n l\xFD c\u1EA5u h\xECnh`,
    8140105: `H\u1EE7y li\xEAn k\u1EBFt MSKU`,
    81402: `Qu\u1EA3n l\xFD Phi\u1EBFu nh\u1EADp kho`,
    8140201: `\u0110\u1EA9y`,
    8140202: `V\xF4 hi\u1EC7u`,
    8140203: `T\u1EA1o Phi\u1EBFu nh\u1EADp kho`,
    81403: `Qu\u1EA3n l\xFD Phi\u1EBFu xu\u1EA5t kho`,
    8140301: `\u0110\u1EA9y`,
    8140302: `V\xF4 hi\u1EC7u`,
    81404: `Th\xE0nh t\xEDch k\xE9o kho`,
    9: `Khuy\u1EBFn m\xE3i`,
    901: `Qu\u1EA3n l\xFD khuy\u1EBFn m\xE3i`,
    90101: `Danh s\xE1ch khuy\u1EBFn m\xE3i`,
    9010101: `\u0110\u1ED3ng b\u1ED9 Khuy\u1EBFn m\xE3i`,
    9010102: `Th\xEAm Khuy\u1EBFn m\xE3i`,
    9010103: `Th\xEAm khuy\u1EBFn m\xE3i h\xE0ng lo\u1EA1t`,
    9010104: `Chi ti\u1EBFt Khuy\u1EBFn m\xE3i`,
    9010105: `Ch\u1EC9nh s\u1EEDa Khuy\u1EBFn m\xE3i`,
    9010106: `X\xF3a Khuy\u1EBFn m\xE3i`,
    9010107: `X\xF3a khuy\u1EBFn m\xE3i H\xE0ng lo\u1EA1t`,
    9010108: `D\u1EEBng khuy\u1EBFn m\xE3i`,
    9010109: `Nh\u1EADp Khuy\u1EBFn m\xE3i`,
    9010110: `D\xF9ng M\u1EABu T\u1EA1o H\xE0ng lo\u1EA1t`,
    9010111: `Xem L\u1ECBch s\u1EED Th\xEAm h\xE0ng lo\u1EA1t`,
    90102: `M\u1EABu Khuy\u1EBFn m\xE3i`,
    9010201: `Th\xEAm M\u1EABu`,
    9010202: `Ch\u1EC9nh s\u1EEDa M\u1EABu`,
    9010203: `X\xF3a M\u1EABu`,
    902: `T\u1EF1 \u0111\u1ED9ng \u0111\u1EA9y S\u1EA3n ph\u1EA9m`,
    90201: `S\u1EEDa Th\xF4ng tin \u0111\u1EA9y S\u1EA3n ph\u1EA9m`,
    90202: `Ch\u1EC9nh s\u1EEDa Tr\u1EA1ng th\xE1i C\u1EEDa h\xE0ng`,
    90203: `Th\xEAm S\u1EA3n ph\u1EA9m \u0111\u1EA9y`,
    90204: `X\xF3a S\u1EA3n ph\u1EA9m \u0111\u1EA9y`,
    90205: `\u0110\u1EB7t quy t\u1EAFc \u0110\u1EA9y S\u1EA3n ph\u1EA9m`,
    10: `Kh\xE1ch h\xE0ng`,
    1001: `Qu\u1EA3n l\xFD Kh\xE1ch h\xE0ng`,
    100101: `Xu\u1EA5t Kh\xE1ch h\xE0ng \u0111\xE3 ch\u1ECDn`,
    100102: `Xu\u1EA5t t\u1EA5t c\u1EA3 Kh\xE1ch h\xE0ng`,
    100103: `Ki\u1EC3m tra L\u1ECBch s\u1EED Xu\u1EA5t`,
    100104: `Th\xEAm Kh\xE1ch h\xE0ng`,
    100105: `Nh\u1EADp Kh\xE1ch h\xE0ng`,
    100106: `Ch\u1EC9nh s\u1EEDa Kh\xE1ch h\xE0ng`,
    100107: `X\xF3a Kh\xE1ch h\xE0ng`,
    100108: `Xem Kh\xE1ch h\xE0ng`,
    100109: `C\xE0i \u0111\u1EB7t Nh\xF3m Kh\xE1ch h\xE0ng`,
    100110: `\u0110\u1EB7t th\xE0nh Danh s\xE1ch \u0111en`,
    1002: `Nh\xF3m Kh\xE1ch h\xE0ng`,
    100201: `Th\xEAm nh\xF3m`,
    100202: `Ch\u1EC9nh s\u1EEDa Nh\xF3m`,
    100203: `X\xF3a Nh\xF3m`,
    11: `B\xE1o c\xE1o`,
    1101: `\u0110\u1ED1i so\xE1t b\xE1n h\xE0ng`,
    110101: `Th\u1ED1ng k\xEA \u0110\u01A1n h\xE0ng`,
    11010101: `Xu\u1EA5t B\xE1o c\xE1o`,
    11010102: `Ki\u1EC3m tra L\u1ECBch s\u1EED Xu\u1EA5t`,
    110102: `\u0110\u1ED1i so\xE1t S\u1EA3n ph\u1EA9m`,
    110107: `Th\u1ED1ng k\xEA doanh s\u1ED1 s\u1EA3n ph\u1EA9m ch\xEDnh`,
    110108: `Ho\u1EA1t \u0111\u1ED9ng s\u1EA3n ph\u1EA9m ch\xEDnh`,
    11010201: `Xu\u1EA5t B\xE1o c\xE1o`,
    11010202: `Ki\u1EC3m tra L\u1ECBch s\u1EED Xu\u1EA5t`,
    110103: `B\u1EA3ng Thu\u1ED9c t\xEDnh S\u1EA3n ph\u1EA9m`,
    11010301: `Xu\u1EA5t B\xE1o c\xE1o`,
    11010302: `Ki\u1EC3m tra L\u1ECBch s\u1EED Xu\u1EA5t`,
    110104: `\u0110\u1ED1i so\xE1t K\xEAnh b\xE1n h\xE0ng`,
    11010401: `Xu\u1EA5t B\xE1o c\xE1o`,
    11010402: `Ki\u1EC3m tra L\u1ECBchs\u1EED Xu\u1EA5t`,
    110105: `\u0110\u1ED1i so\xE1t C\u1EEDa h\xE0ng`,
    11010501: `Xu\u1EA5t B\xE1o c\xE1o`,
    11010502: `Ki\u1EC3m tra L\u1ECBch s\u1EED Xu\u1EA5t`,
    110106: `B\u1EA3ng l\u1EE3i nhu\u1EADn(c\u1EA7n c\xF3 quy\u1EC1n "Qu\u1EA3n l\xFD T\u1ED3n kho")`,
    11010601: `Xu\u1EA5t \u0111\u1EBFn Excel`,
    11010602: `Xu\u1EA5t \u0111\u1EBFn PDF`,
    11010603: `Ki\u1EC3m tra L\u1ECBch s\u1EED Xu\u1EA5t`,
    1102: `B\xE1o c\xE1o T\u1ED3n kho`,
    110203: `Gi\xE1 tr\u1ECB t\u1ED3n kho`,
    110201: `B\u1EA3ng D\u1EF1 b\xE1o H\u1EBFt h\xE0ng`,
    11020101: `B\u1ED5 sung H\xE0ng`,
    11020102: `Xu\u1EA5t B\xE1o c\xE1o`,
    11020103: `Xem L\u1ECBch s\u1EED Xu\u1EA5t`,
    110202: `Th\u1ED1ng k\xEA H\xE0ng b\xE1n ch\u1EADm`,
    11020201: `Xu\u1EA5t b\xE1o c\xE1o`,
    11020202: `Ki\u1EC3m tra L\u1ECBch s\u1EED Xu\u1EA5t`,
    11020203: `T\xF9y ch\u1EC9nh`,
    12: `\u1EE6y quy\u1EC1n`,
    1201: `Sao ch\xE9p C\u1EEDa h\xE0ng`,
    120101: `S\u1EEDa Th\xF4ng tin C\u1EEDa h\xE0ng`,
    120102: `Ng\u1EAFt k\u1EBFt n\u1ED1i`,
    120103: `Th\xEAm C\u1EEDa h\xE0ng`,
    120104: `Qu\u1EA3n l\xFD Kho h\xE0ng`,
    120105: `X\xE1c nh\u1EADn t\xEDch h\u1EE3p`,
    120106: `K\xE9o kho h\xE0ng`,
    120107: `Li\xEAn k\u1EBFt`,
    120108: `C\u1EADp nh\u1EADt`,
    120109: `L\u1ECBch s\u1EED thao t\xE1c`,
    1202: `Th\xEAm \u1EE6y quy\u1EC1n`,
    14: `Chat`,
    1405: `T\u1EA3i Windows Chat`,
    1406: `T\u1EA3i MacOS Chat`,
    1401: `Qu\u1EA3n l\xFD Chat`,
    1402: `M\u1EDF ph\xF2ng Chat`,
    1403: `V\xF4 hi\u1EC7u h\xF3a ph\xF2ng Chat`,
    1404: `C\xE0i \u0111\u1EB7t T\u1EF1 \u0111\u1ED9ng \u0110\u0103ng nh\u1EADp`,
    15: `C\xE0i \u0111\u1EB7t`,
    1501: `C\xE0i \u0111\u1EB7t C\u01A1 b\u1EA3n`,
    1502: `C\xE0i \u0111\u1EB7t S\u1EA3n ph\u1EA9m`,
    1503: `C\xE0i \u0111\u1EB7t \u0110\u01A1n h\xE0ng`,
    1504: `C\xE0i \u0111\u1EB7t T\u1ED3n kho`,
    1505: `C\xE0i \u0111\u1EB7t V\u1EADn chuy\u1EC3n`,
    150501: `Danh s\xE1ch \u0110\u1EB7t V\u1EADn chuy\u1EC3n`,
    150502: `\u0110\u1EB7t C\xF4ng t\u1EAFc V\u1EADn chuy\u1EC3n`,
    1506: `Qu\u1EA3n l\xFD Nh\xE2n vi\xEAn`,
    150601: `Danh s\xE1ch Nh\xE2n vi\xEAn`,
    150602: `Th\xEAm Nh\xE2n vi\xEAn`,
    150603: `Ch\u1EC9nh s\u1EEDa Nh\xE2n vi\xEAn`,
    150604: `X\xF3a Nh\xE2n vi\xEAn`,
    1507: `Qu\u1EA3n l\xFD Vai tr\xF2`,
    150701: `Danh s\xE1ch Vai tr\xF2`,
    150702: `Th\xEAm Vai tr\xF2`,
    150703: `Xem Vai tr\xF2`,
    150704: `Ch\u1EC9nh s\u1EEDa Vai tr\xF2`,
    150705: `X\xF3a Vai tr\xF2`,
    1508: `C\xE0i \u0111\u1EB7t Fulfillment`,
    150801: `D\u1ECBch v\u1EE5 JD Fulfillment`,
    15080101: `Th\xEAm Ph\xF2ng ban`,
    150802: `D\u1ECBch v\u1EE5 Fastock Fulfillment`,
    15080201: `Th\xEAm Kho`,
    150803: `D\u1ECBch v\u1EE5 Ginee Fulfillment`,
    15080301: `Th\xEAm Kho`,
    1509: `\u0110\u1ED5i m\u1EADt kh\u1EA9u`,
    16: `Logistics`,
    1601: `Truy v\u1EA5n ph\xED v\u1EADn chuy\u1EC3n`,
    808: `Danh s\xE1ch s\u1EA3n ph\u1EA9m kho b\xEAn th\u1EE9 3`,
    80801: `\u0110\u1ED3ng b\u1ED9`,
    80802: `T\u1EA1o s\u1EA3n ph\u1EA9m Ch\xEDnh`,
    80803: `L\u1ECBch s\u1EED r\xE0ng bu\u1ED9c`,
    80804: `\u0110\u1ED3ng b\u1ED9 s\u1EA3n ph\u1EA9m kho h\xE0ng`,
    80805: `Li\xEAn k\u1EBFt MSKU`,
    80806: `H\u1EE7y li\xEAn k\u1EBFt MSKU`,
    18: `Mua`,
    1801: `Qu\u1EA3n l\xFD nh\xE0 cung \u1EE9ng`,
    180101: `Xem`,
    180102: `Thao t\xE1c`,
    1802: `\u0110\u01A1n \u0111\u1EB7t h\xE0ng`,
    180201: `Xem`,
    180202: `Thao t\xE1c`,
    180203: `Xu\u1EA5t`
  }
};
